module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "Heading1232435 _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Heading1232435"
  }, [_vm._v("Copyright © Andrea J. Adams 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods,without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other non-commercial uses permitted by copyright law. For permission requests, write to the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("Any person who commits any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Ordering Information")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("Quantity sales: Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the publisher at the address below.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Publisher’s Cataloging-in-Publication data")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("Adams, Andrea J.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("March on the Arch")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("ISBN 9798886937718 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("ISBN 9798886937725 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("Library of Congress Control Number: 2024910767 ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-2"
  }, [_vm._v("www.austinmacauley.com/us")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("Austin Macauley Publishers LLC")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("40 Wall Street, 33rd Floor, Suite 3302 ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("New York, NY 10005")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("USA")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("mail-usa@austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR _idGenParaOverride-1"
  }, [_vm._v("+1 (646) 5125767")]), _vm._v(" "), _c('p', {
    staticClass: "Dedi ParaOverride-3"
  }, [_vm._v("To my mother and father, and to my dear friend Jean M. Howe.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Many thanks to the Exeter Writers group.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Table of Content")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor000"
    }
  }, [_vm._v("Chapter 1\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor001"
    }
  }, [_vm._v("Chapter 2\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor002"
    }
  }, [_vm._v("Chapter 3\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor003"
    }
  }, [_vm._v("Chapter 4\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor004"
    }
  }, [_vm._v("Chapter 5\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor005"
    }
  }, [_vm._v("Chapter 6\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor006"
    }
  }, [_vm._v("Chapter 7\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor007"
    }
  }, [_vm._v("Chapter 8\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor008"
    }
  }, [_vm._v("Chapter 9\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor009"
    }
  }, [_vm._v("Chapter 10\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor010"
    }
  }, [_vm._v("Chapter 11\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor011"
    }
  }, [_vm._v("Chapter 12\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor012"
    }
  }, [_vm._v("Chapter 13\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor013"
    }
  }, [_vm._v("Chapter 14\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor014"
    }
  }, [_vm._v("Chapter 15\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor015"
    }
  }, [_vm._v("Chapter 16\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor016"
    }
  }, [_vm._v("Chapter 17\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/Epub#_idTextAnchor017"
    }
  }, [_vm._v("Chapter 18\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt7.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony and Andi, brother and sister, stood together in their backyard, at the edge of their mom’s garden. With a last look back at their home, a small white cape with green trim, the children turned and stepped into the cool shade of the garden. The neat and familiar tangle of the garden plants now loomed over their heads like a jungle, for they had been reduced in size to just nine inches high. How and why this had happened was a mystery. Where were all the adults? That was another mystery. Everyone they knew, including their parents, had simply disappeared. So here they were, two kids setting out on a journey with just one goal in mind: to climb Stone Mountain and reach the Arch Monument, where Andi believed they would find the answers, rescue their parents, and get back to normal.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi who was twelve, the eldest by one year, led the way. Andi was short for Andrea. Andi liked to be called Andi because it was plain and simple. Andrea was too fancy, she thought. Only her mother called her Andrea at certain times, usually when she was mad about something. Andi was smart and could be bossy because she felt responsible for her younger brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi loved the garden. The dark brown soil smelled good. Green leaves overhead blocked the hot August sun. She led the way between a row of carrots with lacy leaves and beets with red stems. Fuzzy green and yellow beans hung down, and tomato plants bent under the weight of their ripe fruit.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" There is certainly plenty to eat here, Andi thought, it’s too bad Tony doesn’t like veggies as much as I do")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(". She turned to speak to him but he was nowhere in sight. Where did he go?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hey Tone!” she called. “Where are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m up here!” Tony yelled. Tony was short for Anthony, but no one ever called him that. He was small for his age, a friendly boy with a good sense of humor.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi looked up at the cornstalks towering over her, golden tassels reaching to the sky. There was Tony sitting in the crook of an ear of corn, a happy smile on his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What are you planning to do? Hack it off with a tiny knife?” she teased.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I don’t have a knife but I DO have an idea!” Tony jumped out with all his might and reached for the corn silk hanging from the ear of corn. He held tight and swung down as the ear of corn slowly bent under his weight. Then SNAP! The ear of corn broke off and came hurtling down through the leaves with Tony still attached. AHHHHHHHHH! Splat! Tony jumped up unhurt.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“TA DA! Dinner is served!” he announced. They peeled back the husks and there were the beautiful golden kernels.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“This is great! Well done, Tone! But we have to eat it raw? Oh, what I wouldn’t do for a little butter and salt!” Andi said, just to make her brother laugh. “Well, here goes!” They knelt down and bit into the fat kernels and the sweet juice sprayed everywhere. It was yummy but sticky.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Suddenly something was moving through the plants. A marching line of shiny black ants, each with six legs and two twitching antennae, approached their ear of corn. Andi and Tony sat still, watching. The ants swarmed onto the corn, ignoring the children. Tony leaned over and whispered, “Did you know that scientists estimate there are a million ants for every one human on earth?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That’s a lot of ants,” Andi said quietly. “What else do you know about them?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Umm,” Tony’s forehead wrinkled as he thought. “Well, they used their antennae to smell that corn. They’ll take some back to their nest to feed their baby ants called larvae, and they can communicate using chemicals called pheromones.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi said, “Wow, you know a lot about ants.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony smiled. “Thanks!” He was happy to impress his big sister who everybody always said was so smart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony declared, “Insects are cool!” It was Andi’s turn to smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yup, I think so too,” she agreed. “Had enough corn, Tone? Maybe we should find a place to sleep for the night.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("They laid some fuzzy mint leaves down on the earth and covered themselves with spinach. They nibbled at their blankets, or at least Andi did. Tony had never liked spinach. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("What will he do without pizza and French fries? ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi thought to herself smiling. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("How will he ever survive?")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(" She looked at him already sleeping peacefully next to her. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("He’ll be okay. I’ll look after him")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(". She closed her eyes and listened to the crickets and other night noises, the rustlings and twig snappings. Funny, she was not afraid of the dark here. “Good night, Tone,” she whispered.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony was already dreaming of a few of his favorite things: playing his drums, hitting a baseball, eating pizza, and finally stretching out on the sofa to watch a little TV. He slept on quite peacefully till morning.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt11.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’m thirsty")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(" was Tony’s first thought next morning as he stretched to uncurl himself. As he stood up and looked around, he heard birdsong. Andi liked birds. They were no big deal to him. He moved toward a glistening that was shining from the cucumber patch and discovered it to be morning dew held in a blossom. A drink!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Andi, look at this, here’s a drink of dew. Ouch! Watch the spines on that vine.” Tony looked around and thought about what he could use for a water bottle when they left the garden. And when would that be?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s have some more corn for breakfast and make a plan, okay?” he suggested to his sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Sure.” Andi opened her eyes and looked up. The sun was shining down through the green canopy above her. Blue sky was visible here and there through holes in the leaves that some garden pest had chewed. She noticed her spinach blankets had wilted. Nearby a big slug sat atop their ear of corn.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hey, get off there, that’s ours. Oh gross!” she laughed. “Now that the slug has licked our corn, we’ll just have to harvest some more.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s do that, but don’t be mad at the slug, it’s just doing what it’s supposed to do, you know. Slugs play an important role in the ecosystem by eating decaying plant material,” explained Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m not mad. That’s good to know! It’s just that Mom doesn’t like them chewing her tomato plants. And later you can explain ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ecosystem")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(". But first things first. Let’s eat!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("As they sat munching more corn, a blue jay jabbed its beak through the leaf canopy and speared a cabbage worm. A large robin with a rusty round belly stopped hopping, cocked its head, and pulled an earthworm out of the soil. The worm wriggled as the robin lifted off and flew away. A ladybug crawled along a tomato plant stem, looking for tiny green aphids to eat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Wow, we’re really getting a good view of nature, aren’t we? Creatures eating other creatures to survive,” observed Andi seriously.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yup,” agreed her brother. “Soooo…what about us? At this size, how do we defend ourselves?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Good question. Why don’t we take an inventory of what’s in our pockets?” suggested Andi. Tony pulled everything from his pockets. A homemade slingshot; a couple of glass marbles; less than a dollar in change; a movie ticket; a golf tee. And that was it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I hope you have more than that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Not much, let’s see, here’s my l0X, it’s a magnifying glass, and my little spiral notebook for writing stuff, a folded up note from Annie, and my Swiss army knife,” replied his sister. Her pride and joy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Cool! Show me all the gadgets it has! Can I try it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yeah well, it’s not a toy and you could hurt yourself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“You sound just like Mom!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“You’re right, I do. I’m sorry. Here, check it out, just be careful. We’ve no matches, unfortunately, and no way of making a fire. And we have no phone or way of communicating with the outside world.” Tony and Andi now existed in a world without electricity or comforts or conveniences of the modern world. How would they survive?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How about we pick some blueberries! I’m still hungry!” Tony called this over his shoulder as he was already moving toward the berries.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We just had breakfast! Race ya!” challenged Andi, and they both took off running.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The blueberry bushes were at the back of the garden, close to where the family backyard was bounded by town land. A wide field of tall grass dotted with wildflowers rose up and up toward a line of trees close to the summit of Stone Mountain. That was where they had to go, up there. Eventually. But right now, those big blue berries were calling.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Just then, Tony came to an abrupt halt and put his hand on his sister’s arm to stop her and whispered, “Hey, look! We’re not the only ones who want to eat blueberries!” Ahead of them in the berry bushes they could see bluejays and robins. The birds seemed to eat the berries whole and were gobbling them fast, one after the other. Under the bushes, a squirrel and a chipmunk were delicately nibbling one berry at a time. On the other side, a whitetail deer reached for the stems and fruit hanging from the higher branches near the top. A cottontail bunny was busy chewing as it sat in a patch of heart-shaped violet leaves.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yikes, Mom better put netting on a few bushes if she wants any berries!” whispered Tony. “Let’s see what happens next.” And he walked out from under the cornstalks and stood watching the wildlife. They all stopped and stared at the two kids. And Tony, out of the blue, announced, “Hi! I’m Tony, and this is my sister Andi,” in the friendly way he had. And suddenly each of the other creatures answered, “Hi” back in their own voice. The bluejay squawked it. The robin trilled it. And the squirrel and the chipmunk and the rabbit and the deer. They all said quite distinctly, “Hello!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony stood with mouth open. “You’re talking! Sweet!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi couldn’t believe it and asked herself, “What is happening?” There was definitely something weird going on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The gray squirrel came forward and said, “Of course we can communicate. It’s a pleasure to meet you. Come and have some of these juicy berries.” And so they did. Andi climbed into a bush and out onto a branch with a big load of berries. The branch bent under her weight so that Tony was able to reach the fruit, and he picked as fast as he could. For every berry he put aside, he stuffed two or three into his mouth. Pretty soon his face and hands were stained purple. Then he took a turn pulling down a branch so his sister could reach the blue fruit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That was delish! Now what?” Tony grinned at the squirrel and the rabbit. “Who’s the fastest?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m Cecil, and I’m the fastest,” boasted the gray squirrel, and twitched his plume of a tail.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m Ella, and I’m the fastest,” stated the brown rabbit, sure of herself, and twitched her silky ears.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Cecil raised his voice and blustered, “Why I’m so fast I could… I could… I could beat you in a race with him on my back,” pointing to Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Okay, okay!” laughed Tony. “Let’s see, let’s have a race! How about down the row of corn and back?” So Cecil said, “Sure!” and Tony hopped on his back.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Ella looked at Andi and said, “C’mon, we can beat ’em!” and so Andi climbed onto the rabbit’s soft fur and looked over at Tony in the next row.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ready! Set! Go!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Cecil and Ella practically flew down the rows and made the fastest turns they could at the end of the row. Dirt and grass flew out as their claws ripped into the turf to keep their balance, and then back down the row to the finish line. It looked like a tie race. Now there were spectators along the rows, four footed and winged, calling and cheering the racers on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yahoooo!” and Tony lifted a hand into the air like a rodeo rider. “Hold on tight or you’ll fall off!” yelled his sister. And then he did go flying off, banging into a cornstalk and landing face down in the dirt. Andi and Ella came through the stalks and everyone rushed to Tony’s side. Andi turned him over. His face was dirty and he was spitting dirt, but he was smiling, and he soon hopped up, slapping the mud off his knees. “Was that fantastic or what! Let’s do it again!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi was about to agree when a young bluejay limped forward. Andi could see one foot was dragging and knelt down to look. “It must be broken. I could splint it with a stick and a bit of garden twine. Maybe that would help it heal properly.” She handled the broken leg as gently as she could. “There,” she said when she’d finished. “I hope that helps.” The little bird squeaked a thank you and began stumping up and down, trying out his mended leg. All the animals looked at the leg and then at Andi.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("A bluejay hopped down from her perch in the corn above, landing in front of Andi, and said, “Thank you for mending my son’s leg, Andi. Would you like to take a ride on my back? I think I could carry you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh yes,” Andi cried, and carefully climbed onto her back. The blue feathers were gorgeous and Andi was thrilled. The bird flew low between the rows of cornstalks. Andi looked to her left, and there was Tony on the back of a robin, flying along beside them in the next row. Here we go again! This time Tony stayed on till the finish line, and the race ended in a tie. Andi was ecstatic. She loved and admired all birds and daydreamed about having wings and flying like a bird.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The two kids stood around with their new friends, chatting and laughing. Late afternoon sunbeams slanted long beneath the garden foliage. Eventually the light faded and the twilight dimmed all colors to gray. Everyone said good night. Tony and Andi moved through the garden unhurried. They were pretty tired. Tony looked at his sister. “That was terrific the way you fixed that bird’s leg.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Thanks Tone. I hope it helps.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How did you know how to do it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m not sure. It might have been something I learned from Mrs. Northstar.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh you mean the old lady who lives at the end of our street?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes, but she’s not just an old lady. She’s wonderful. She knows a lot about all kinds of stuff.” Andi weeded the flowers and trimmed the grass around the edges of Mrs. Northstar’s lawn every Saturday during the summertime. When she had finished the weeding, she’d go inside to be paid a small fee for her work, and Mrs. Northstar would serve steaming tea scented with oranges and spices and sweetened with honey, and yummy cookies, and they’d talk about all kinds of things. The elderly woman and the young girl had become good friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("It had been a beautiful day, and Andi and Tony were in their mom’s happy place, and so they were happy too. They spent another night under the stars in the garden. Soon they would have to move on, through the grassy fields and up to the woods near the top of the mountain, then to the Arch Monument where their journey would end. What would they find? How would they manage at this size? First they had to get there. First they had to sleep…")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi lay down and looked up at the stars through the leaves of the tomato plants. Orion’s Belt and the Big Dipper were familiar friends in the night sky. Her dad had showed her. And also how ducks fly; how to hook a brook trout hiding in a pool; where to look for deer tracks and bear scat and a million other cool things that dads know. She missed her dad and hoped he was safe wherever he was. And Mom too.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt19.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Chapter 3")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("It was August so the hot and sunny days alternated with cool nights full of stars. Andi and Tony spent their time exploring and getting to know the garden’s residents. Once in a while, it rained during the night. The watering can would be filled with rainwater, and the kids would tip the can for each other to get a cool shower from the spout. Oftentimes a creature would appear with some sort of injury; maybe a sliver in a paw or a speck of something in an eye. Andi would do her best to help, using what knowledge she had along with cleanliness and gentle fingers. Tony, on the other hand, was the treasure seeker. He would roam and scout all over and bring back all kinds of useful things. Or at least things that were fun and interesting to an eleven-year-old.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("One day Tony returned from his explorations skipping and shouting, “Andi, Andi, look who I’ve found! Jo Jo!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh Jo!” Andi ran to her friend and hugged her hard. “It’s so good to see you!” Jo was short for Joanne, who was eleven years old like Tony, and her family lived next door to Tony and Andi. Randy and Matt were her big brothers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Where are Randy and Matt and your parents?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I don’t know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Tony, what is that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“It’s a sword I’ve made from a wood splinter off the fence. You told me to prowl and procure and haven’t I done just that! A sword and a friend! Here are a few more wood splinters for a sword for each of you. I’ll make them for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Jo, are you hungry?” asked Andi. “I hope you like veggies?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Sure! I’m tired of eating crackers and cereal. I was stuck inside our house all alone but finally escaped through Tiger’s flap door. Tiger was Jo’s big yellow kitty. I don’t know where Tiger is or my family.” Jo’s eyes began to fill with tears.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Don’t cry Jo, you’re with us now,” said Tony kindly, and he reached for her hand. “C’mon, let’s race to the blueberries, and I’ll introduce you to some of our friends!” And so the two friends ran off together. Just to make Jo giggle, Tony dove down into a chipmunk hole and got stuck, his feet sticking out and pumping up and down. He hollered, “Help! Get me out!” So Andi and Jo each took a leg and pulled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What’d you see down there?” asked Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Nothin’. Black as night in there!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Later that night, the three kids sat together talking quietly. The moon shone brightly. Stars twinkled. Crickets chirped. An owl hooted…whoo-whoo-who­whooooo! “I think that’s a barred owl!” Andi shared with her companions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How do you know?” asked Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Mrs. Northstar has been teaching me to recognize birds by their calls.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh yes, she’s nice, isn’t she?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Very.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Will you come with us Jo?” asked Tony hopefully. “It may be a long journey and we don’t yet know how it will end.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“There’s no reason for me to stay here. I can’t find my brothers or my folks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“They may come home and search for you. In that case, you should stay nearby,” Andi suggested.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo had made her decision. “I’d rather stick with you two.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yay for us! We’ll have to leave the garden soon. I’ve been keeping a calendar in my notebook. I think we should leave on the first of September so we have three days to get ready. We don’t know what we’ll find once we leave Mom’s garden. We’ll need to take water and food.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“And I’ve made weapons!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We know Bub.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Andi, don’t call me Bub.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m sorry, it’s a habit and it pops out before I can think about it and stop myself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Well, please try not to do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Okay Bub.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“ANDI!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oops, I’m sorry Tone. Good night.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“G’night Jo.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“G’night Andi.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The next morning was cloudy and a light rain fell. Under the garden foliage, the three kids stayed mostly dry. Jo checked her pockets. She found a house key. A comb (she had long and shiny straight brown hair that Andi envied). Oh, and a cell phone.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“A CELL PHONE! Have you called your mom? What happened?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“She never answered so I’ve turned it off to save the battery.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Electronics are useless out here,” said Tony. “Better hang onto it though, it may come in handy at some point.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi and Jo dug up an orange carrot, picked a few yellow beans and a green bell pepper. Along with some red cherry tomatoes, chives and parsley, they created a real rainbow of a salad. Jo bit into a jalapeno pepper and her eyes got big and watery and her face turned red. Andi quickly cut into a round watermelon and Jo cooled her mouth on the juicy sweet fruit. Afterward they munched blueberries, and Tony showed the girls his method for swinging down and breaking off a few ears of corn. The three kids worked together, neatly laying out the berries and corn on flat stones at the edge of the garden. When the clouds blew over, the hot August sun would dry the berries and corn into chewy leathery trail food. At least they hoped it would.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We could try drying tomatoes too… or the beans?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Not for me!” piped up Tony, waving his sword around with a Swish! “Wish I had a burger and fries right now!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ya know, some people eat nasturtium blossoms. They’re sweet! And squash blossoms stuffed with stuff.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh brother!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Mom loves nasturtiums and she planted a ton of ’em. Let’s try some! I love the leaves too. I read a book that said little fairies use nasturtium leaves as umbrellas.” She picked one and twirled it over her shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Do you believe in fairies, Andi?” asked Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Of course. I believe in all magical things, do you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yup!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Nah!” Tony wielded his sword. “Ahoy matey, I’m a pirate!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Well, little fairies are wonderful to imagine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Are you afraid of the dark? Or of monsters under your bed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes, I was. But then my dad came in and turned on the light. And he knelt down and looked under my bed, and he showed me there was nothing there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Just then, a large bumblebee exited an orange nasturtium blossom and buzzed close to Jo. She jumped back and looked scared.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m scared of bees,” she said. “They sting.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Don’t worry Jo, that bee is more interested in gathering nectar than it is in us. Look at those big yellow blobbies of pollen stuck to its back legs.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What’s that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That’s how bees help pollinate plants so they can produce fruit. You know what that means?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ahhhhhh… not really.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I think the bee flies from one plant to another looking for food. Along the way, the pollen from one plant sticks to its legs and then gets carried to another plant, which uses it to produce fruit. Bees are very important creatures!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“And what about that nightcrawler over there? What do they do?” The worm had come up out of the dark soil.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The pirate piped up, “They make good bait for trout!” He swished his sword, adding, “And they aerate the soil which is good for the plants.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Aerate?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ya know, they dig lots of little tunnels in the dirt so air and water can get to the roots.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I see. I know about ladybugs,” said Jo. “They eat smaller insects that would otherwise harm the garden plants, like aphids.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Wow how do you know that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I did a science project on ’em.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Sweet!” admired the pirate.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo asked, “Gee, I wonder if we’ll be going to school again soon?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hope not! This is way more fun.” Swish-swish went the sword.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi shared, “I don’t know. I kinda like school.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ah ha! Bookworm!” The pirate pointed his sword at his sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Nothing wrong with reading a good book, Tone! And how would you even know about pirates if Mom and Dad hadn’t read ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Treasure Island and Swiss Family Robinson")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(" to us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh yeah. Well, that may be true, but I still don’t like school, and I’d rather sword fight. C’mon sis, grab your sword. On guard!” In the shade of the cornstalks, the three children practiced dueling with their homemade swords, running and laughing up and down the rows. And almost bumped into a toad with brown bumpy skin and big eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hello,” said the toad.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hello to you,” Andi replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“And what are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m a girl. We’re human beings.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What are you doing here in my garden?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Your garden? But it’s our garden!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’ve never seen you here before.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That’s because… because… oh, it’s complicated,” said Andi.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("She plopped down on a rock and thought for a minute. The toad moved a little closer, waiting patiently.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’re here because something or someone shrunk us down to this size. But this was always our garden. My mother’s garden. And I help her plant it and weed it. Only now I don’t know where she is or my dad or anyone else. Tony, Jo and I seem to be all alone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“So what are you going to do? What are your plans?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’re going to make our way through the grasslands, then the woods, up to the Arch Monument to try and set things right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“An adventure. A dangerous journey,” remarked the toad.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Why dangerous, Mr. Toad?”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt26.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "InDent-Txt"
  }, [_vm._v("“Rumors. I’ve heard rumors.”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Like what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“They have spies…”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo sat on a mushroom cap and stared in surprise at the toad.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Mr. Toad, what else can you tell us?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Just to take care. You’ve been very kind to the animals here. They’ll help you. Call on them whenever you’re in trouble.” And with that, the toad hopped away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony said, “Spies! Cool!” We’ll show ’em!” He reached for his sword but was really too tired to swish it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And by then it was evening and Andi observed, “Looks like it may rain. Let’s scoop out this giant pumpkin and climb inside. Mom won’t mind. We can sleep in it if it rains tonight. Put those sword blades to some real use.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Later, Andi woke up inside the pumpkin and crawled out to see the night. The rain had stopped and the nearly full moon was coming out from behind the clouds. Here and there silver moonlight was pooling on the garden floor. Tony and Jo were curled up sound asleep. Andi blinked. What were those two small points of light ahead in the gloom? The lights disappeared, then reappeared only closer. How curious. Suddenly a fox stepped out from the shadows, and Andi could see that the two points of light were its shining eyes. Sharp white teeth were visible in its open mouth. Andi and the fox were practically the same height as they confronted each other. Hoping the fox would think her too big for a meal, she gave her brother a little kick with her foot. “Pssst…look Tone, a fox!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("He sat up, nudging Jo to do the same. Suddenly the fox spoke.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hello, you’re new around here, aren’t you? You must be Andi. I’ve heard about you. I’m Tanya.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes, I’m Andi. Very nice to meet you, Tanya. What are you doing out and about tonight?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Foxes are nocturnal, you know. I must hunt as I have four young kits to feed,” explained the vixen, for that is what a female fox is called.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh, of course. That’s a gorgeous tail you have.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tanya proudly flicked her tail as she acknowledged the compliment. “Thank you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’re leaving here soon. We’ll be climbing up to the Arch monument. “Have you ever been there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh yes, many times.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Have you noticed anything odd about it lately?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Other than little lights in the sky at times, not really. If I see anything, I’ll let you know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Mr. Toad said—”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ah, Old Toadie… he’s not very tasty.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“He said something about spies.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I don’t know about spies. Why don’t you ask the crows? They get around and from high up in the treetops, they may see more than I do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh, that’s a wonderful idea. We’ll do that first thing tomorrow. I appreciate the tip. I hope we meet again Tanya. Good night!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Take care and good night!” replied the fox, and she turned and disappeared back into the shadows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi crawled back into the pumpkin and lay down next to her companions. Tony said, “Gee, she was nice and helpful. I don’t think she deserves the bad reputation that foxes have for being cunning and full of mischief. A nuisance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Right. She has to be a good hunter to feed her children.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Even if it means stealing eggs from someone’s chicken coop?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hmmm… I’ll have to think about that. Good night!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Good night!”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Chapter 4")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("It was their last morning in the garden. Andi pondered a spider web all glistening with dewdrops too beautiful to touch. Then the three children went looking for their squirrel friend Cecil. They asked him to climb the tall pine at the back of the garden and speak to the crows on their behalf. After a while, a crow flew down from the tall pine and landed lightly near the berries where the kids were waiting. The crow hopped up and said, “Hi! I’m Luke. Cecil said you need my help. Are you Andi? I understand you’ve been very kind to my neighbors, Andi. How may I be of assistance?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’re glad to meet you, Luke. We’re leaving tomorrow to hike up the Mountain to the Arch. We wondered if, from your bird’s eye view, you’ve noticed anything peculiar happening at the Arch? Or here in our neighborhood?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Can’t say that I have. But would you like to see for yourself? Hop on and I’ll take you up to the top of the pine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh gosh, yes! Let’s go, I’m ready!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And so Luke flew around the tree higher and higher until he carefully came to rest on a branch near the top of the pine. Andi looked out, excited to see her neighborhood from this high lookout. The tree was twice as high as her parents’ house. She had climbed to its top once when she was her normal size. It was pretty easy, she just got a little sticky from the pitch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Today everything looked as it should. She looked down on the pool in Jo’s backyard. The garden in her own backyard with the rusty swing set and campfire pit. A fenced kennel stood behind the next house, and then Mrs. Northstar’s chicken coop and white beehives at the end of the row.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("But there was no sound. The whole world had gone silent. No lawnmowers or little planes buzzing in the sky. No one on skateboards crackling on the pavement, or skates or scooters. No walkers or riders of bicycles. No sound of big trucks humming out on the highway. No car engines or horns blowing. No motorcycles backfiring. No voices. Or dogs barking or children playing. Life had been interrupted by something. She turned toward the Arch. It stood tall at the top of the mountain, shining in the sun. Nothing seemed out of place. Then she saw a regular flash of light on top of the Arch. A beacon? A spinning antenna? Weird. Why?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("At the base of the pine tree, her backyard met the town land. The town land was a field of tall grass that climbed up steadily to a line of woods. Beyond the woods was the Arch on the summit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The grass was dotted with flowers. It looked innocent enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Thank you, Luke. I’m ready to go back now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("When she was on the ground and reunited with Tony and Jo, Andi said to Luke, “Thank you again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("To which Luke replied, “If you need me, just call and I’ll be there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi told her two companions what she had seen. She seemed so quiet and serious that Tony felt he had to do something to cheer her up on their last night in the garden. He spoke quietly to Jo and they went off together. Andi sat in the doorway to the pumpkin. She would miss this place. She thought of her parents. But then a racket and a commotion were coming toward her. Tony and Jo were dancing along and singing a made-up song. And behind them a parade of animal friends calling to Andi as they marched past.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Bon voyage!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Good luck Andi!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Call on us if you need any help!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Thank you for everything, hope you solve your mystery.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“It was a pleasure to know you! Bye Cecil! Bye Ella! Bye Mr. Toad!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tomorrow they would say goodbye to Mom’s garden. For now they spent their last night making up silly songs and telling funny jokes. Andi was feeling hopeful by the time she fell asleep.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt33.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Chapter 5")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony, Jo and Andi were ready to go. Bottles of water and homemade bags of berries and corn hung from braided cords over their shoulders. (Tony and Jo had rummaged through Jo’s old Barbie and GI Joe collection for canteens and camo pants). Swords dangled from their belt loops. Fond goodbyes had been said to their garden friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Now they stood and looked up at the wall of grass twice as tall as they were. Bordering the back of their garden and yard, the grass separated the familiar world from the wild and unknown. Grass stems stood rather like a bamboo forest, tall and straight without branches, each with a feathery head of seeds, not green but dry and golden yellow. Here and there in the grass grew black-eyed Susans, purple asters, Joe Pye weed, Queen Anne’s lace, and tansy. Heavy heads of goldenrod hung gracefully down. Milkweed stood tall with pinky purple blossoms and pods split open oozing milky sap, black striped Monarch caterpillars feeding on their leaves. Some people called these plants weeds, but Andi thought wildflowers were beautiful. And useful. Crickets and grasshoppers hopped and chirped as they went about the business of living. All sorts of bees and dragonflies buzzed from blossom to blossom, their transparent wings reflecting sunlight.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The wall of grass before them looked impenetrable, but being small they noticed tiny trails opening through the stems made by other small creatures in their secret comings and goings. The sun shone down, the sky was clear and blue, little white clouds skittered along. The world of grass seemed a friendly place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Here we go guys!” called out Andi. “Goodbye garden!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And so they plunged in. The grass was over their heads. Once they began traveling through it, they would not know where they were going. This was a problem they had discussed at night as they sat in the garden. One idea was to shimmy up a plant with a thick stem to see out over the grass. Andi had a general idea of direction and knew they must travel east. The sun rose in the east, so in the morning, they would head toward the sun. In the afternoon, the sun would be behind them. It was now September, and they could not afford to dilly dally.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Achoo! Achoo! Achoo! My nose itches,” Tony complained. They hadn’t been marching along the narrow trail for very long. Tony stopped and rubbed his nose.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“It’s that time of year. I feel itchy and prickly all over. Can we stop?” he asked. So Andi and Jo stopped and turned to look at Tony bringing up the rear. He rubbed his nose with his sleeve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi said, “You need a tissue!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo said, “My big brothers blow their noses without tissue when they are outdoors. Here’s what you do. Lean over and cover one nostril with your pointer finger nice and tight, then blow out the other side of your nose hard and fast. All the goo will fly out and not land on you. Then do the other side.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“It works!” Tony wiped his nose with his sleeve afterward just to be sure.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes but not in the house or at school. I have a feeling Mrs. Brown would not like that at all! Or Mom!” laughed Andi. “Thanks Jo! Let’s move out!” And now Tony took the lead. The dry grass snapped and cracked under their feet. They definitely would not be surprising anyone. They trekked and trekked till Tony plopped down, needing a rest. Suddenly he was bounding up again and shimmying up a sturdy tansy stem. He gazed all around, shielding his eyes with one hand, hanging on with the other, and reported to the girls.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I see miles and miles of grass and butterflies and the sun is hot. It’s bright up here. I can see that hazy, rippling effect in the air… uh oh, hey! This plant is beginning to droop. But I think we’re going in the right direction. Coming downnnnn!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo and Andi wanted to see too, so they climbed up some tall stalks of purple aster. Surrounded by a sea of grass, they saw dragonflies delicately poised on blossoms nearby. In the distance, the grass climbed the hillside, rising up toward the woods. The view was peaceful but daunting. They slid down and looked at each other. There was a long way to go.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s get going,” said Jo. “I can go a little further, can you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo led now, trudging along the narrow trail between the stems. She could feel the path climbing up, up, up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s sing!” she called over her shoulder. “Jo, what song would you like to sing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Well, I really like the Beatles song, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("We Can Work It Out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“But I still love Raffi’s song ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Baby Beluga")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(". Is that weird?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“No!” Andi and Tony joined in to sing the song that all three kids remembered with love.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“My turn!” grinned Tony, and he began:")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“99 bottles of beer on the wall, 99 bottles of beer!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("You take one down and pass it around 98 bottles of beer on the Wall!”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt37.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "InDent-Txt"
  }, [_vm._v("“Oh brother!”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Later it was Andi who asked if it was okay to take a break. Tony and Jo nodded their heads up and down and looked around for a place to rest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Why don’t we go off this path a little way just in case someone or something comes along later tonight?” suggested Tony. Good idea. They pushed their way through the stalks of grass a short distance and began tamping down the grass in a rough circle. Finally they flung themselves down on the ground, hungry, thirsty, and tired out. The three companions munched on some of their supplies and quenched their thirst, settling down for some shuteye. Above them, only a small circle of night sky with a few bright stars was visible. The first night away from the garden passed uneventfully except for a few mysterious rustlings and squeakings, and all their dreams were happy ones.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Chapter 6")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("In the morning, they brushed off their clothes and pulled the grass and seeds out of their hair as best they could, and then they were on their way, with Tony in the lead. It wasn’t long before he stopped abruptly, causing Jo and Andi to bang into him. What is it? A snake lay coiled on the trail, blocking their way. Its bright black eyes were shiny as it looked at them and flicked its tongue.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“It’s a garter snake,” Tony whispered. “See its yellow stripes on a black background. She flicks her tongue to smell the air. She’s a carnivore, an eater of small prey like mice, slugs, or crickets.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’re too big to be its prey, aren’t we?” worried Jo. She looked at the snake over Tony’s shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The snake raised her head. “Yes, I believe you are,” she replied. Did she sound disappointed?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Just then a shadow darkened the path from overhead. Instantly, the snake was uncoiling and moving off the path. “Gotta go!” she hissed. “Take care!” and sped away on her belly as all snakes must. What was that? After a minute, the shadow returned. Looking up, the three travelers saw a red-tailed hawk with large brown wings outspread make another pass over the spot where they stood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi whispered, “We better watch out for her ourselves. Hawks have incredible eyesight, and we are just the right size for her next meal!” Tony dove into the grass to the side of the trail and Andi and Jo followed, wasting no time. They lay in the grass for a while in silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That was close,” Jo remarked as she sat up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I read that prey usually have some sort of defense,” Tony explained. “You know, skunks smell bad, toads taste bad, rabbits can run fast or stay still and hide quietly. And there’s camouflage.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“But what defense do we have?” asked Jo. “At this size, we could easily be some creature’s next meal!” The three kids sat in silence as they pondered Jo’s question. Finally, Tony stood up. Looking seriously at his companions, he said, “We have our brains, our swords, and each other. If we stick to the trail, go as quickly and quietly as we can, and mind our own business, we may get there in one piece.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“No more singing?” smiled Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Right, and most of all, we stay together,” added Andi.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And so that’s what they did, for days and days. Trekking, trudging, and toiling along during the day, Tony, Jo and Andi would occasionally stop to rest and to climb up the wildflower stalks to see what they could see. From time to time, their path would cross with that of an animal friend, and so they would stop to engage in happy conversation and ask for news of the world beyond the sea of grass. Resting at night, the three companions chatted quietly in the dark. Laying on their backs in the grass, they looked up to see only that small circle of sky. Luckily for our friends, they encountered no more large predators on their march through the grass.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("At the end of one such day, Tony said, “You two sleep, and I’ll stay awake and keep watch for a while.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Thanks, Tone. Good night.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony leaned back and laced his fingers behind his head. Looked up at the night sky. Wondered about the stars, those tiny pinpricks of light way up there. Were there living beings out there? On planets like ours orbiting those stars? I wonder what they look like, those alien beings…like people or like giant ants? Were they friendly? He fell asleep without any answers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("In the morning after a bite to eat and a drink of dew, Andi, Jo and Tony strapped on their swords, loaded up their gear, and hit the road again… or rather, hit the mouse trail… hiking single file, listening and observing as they trekked along the track. At midmorning, they took a break as usual. This time, Andi climbed a thick stalk of milkweed and looked out. It seemed a perfect September day. She saw the usual butterflies, blue sky and field of waving grasses. And there was a giant flock of black starlings, hundreds or thousands of birds all flying close together whirling around in formation, not bumping into each other. What was the name for that? A murmuration. Amazing. But today, there was something even more unusual. There seemed to be a gap in the grass up ahead. She couldn’t see what it was and tried to recall running through the fields when she was still her normal size. What did she remember about that sloping field of grass? Tiny wild strawberries in summer; the town’s tractors mowing the grass and baling the hay in the fall; sledding and skiing over the fields covered with snow. Wasn’t there a gully, a sort of ditch that cut across the field like a brown gash with large rocks sticking out? Yeah. As she said this to herself, she noticed clouds approaching from the west, blotting out the blue sky behind them. It had been so sunny and warm for the past few weeks, with not much rain. Now then, they might get wet.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("She slid down, about to announce the approaching clouds, when a racket and a clamor could be heard coming down the trail. “Something’s coming! Quick, let’s climb!” They scooted up the nearest green stalks and waited. Suddenly an actual dog came into view on the trail below, reduced in size as they were, but still a perfect dog, looking up at them with big brown eyes, barking, big ears forward, tail wagging! “Barkley! Barkley, quiet!” The dog stopped barking and turned his head toward the voice. Whose voice? A thin boy suddenly came into view, cap on backwards, long arms and legs, jeans and t shirt, sneakers with holes. He knelt next to the dog, patting its head and saying, “Whatcha got boy?” He looked around and finally looked up. Andi let out a yelp. “Mikey!” The boy’s mouth dropped open in shock. He stood up and grinned wide. “Hi Andi!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The three kids slipped down from their perches and gathered around Mike and his dog. “Hi Joanne. Hi Tony.” He said, “What are you doing here? Where ya headed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Right back atcha Mikey! Where are YOU going? Where have YOU been? And how did Barkley end up our size?” Andi wanted to know.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony asked, “Does Barkley bite?” He had had a run in with a big dog before and was a little bit afraid of Barkley, who stood half as tall as he now did.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Nahhh. He’s friendly, just take it slow so he can get to know you.” Tony held out his hand to Barkley, who sniffed it. Tony smiled and slowly patted the dog’s back, and Barkley wagged his tail. “He likes me! Wish I could have a dog,” he muttered, as he knelt to give Barkley a hug. Barkley licked his face. Andi and Jo were preoccupied with greeting the dog too but were interrupted by a boom and a crack from the sky, and the trail lit up. Overhead the sky had become quite dark. Thunder and lightning. An electrical storm, and they were out in it. “Maybe we should continue this discussion under cover!” Andi suggested.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Chapter 7")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Where are you headed?” Mike began again. Another boom of thunder and lightning crashed overhead. Andi replied as she picked up her gear. “Up the mountain. C’mon. Wait, first let’s look out again and see what’s happening. I think I smell smoke.” She dropped her gear and climbed again, the others doing the same. Peering out from the tops of the plants swaying in the wind, they could really smell the smoke now. Wispy bits of gray fluff began to float past, and black clouds of smoke rose into the sky behind them. They could hear the crackling of burning grass and sparks. The air became hot, and behind them on the horizon, they could see an orange red glow. It was a brushfire and headed in their direction.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And suddenly beneath them and down on the path there was a rush of feet as all sorts of creatures hurried to escape the fire. “We gotta go!” someone yelled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("They ran with the hot wind blowing at their backs. The smoke made their eyes sting and water. The loud crackling and snapping sounds of the burning grass sounded close but no one dared stop to turn and take another look. Jo tripped and fell, dropping everything. “Wait!” she screamed in a panic, scrambling up. Her friends were by her side in an instant, helping to gather her things and then resuming their run. A dark shadow appeared out of the grass. It was Tanya, their fox friend from the garden. “Hurry!” she said. “Climb on my back.” Jo and Tony hopped and pulled themselves up, grunting, finally sitting astride her back, wrapping their fingers around her thick soft hair. A second fox stepped out onto the path. “This is my mate, Toby,” said Tanya. “Andi, hurry, up on his back!” First Andi, then Mike with Barkley in his arms, climbed onto Toby, and he began to sprint up the hill through the grass. Andi was holding on to the fox’s fur, then to Mike’s shirt. She had to let go to rub her eyes and almost fell off. The foxes easily avoided and leapt over the parade of smaller animals, mice, skunks and moles, turtles and snakes. They were all trying to escape the flames as best and as fast as they could. Unconcerned with each other, whether predator or prey, the creatures concentrated on outrunning the fire.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The two foxes ran on. Andi closed her burning eyes and covered her mouth, hanging on as best she could. Large drops of rain splashed her face. Will the rain put out the fire? Galloping on, Tony and Jo clung to Tanya, gasping and coughing. On through the smoke the foxes ran, the crackling of burning grass now roaring all around, hot red sparks floating in the air, settling on the grass beside them, igniting everything till it seemed they were running through a tunnel of fire. And yet, hard drops of rain began to hit them in the face, pelting down on everything. The kids couldn’t see, could hardly breathe. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("How can these animals keep going like this?")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(" Andi thought, and then the fox on whose back she was riding came to an abrupt stop. And peering out through watery eyes, she saw before them the gully, now full of rushing water, blocking their way.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike leaned down and yelled in Toby’s ear, “Can you swim? We’ll never make it across on our own.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Toby smiled and replied, “Of course I can swim.” Mike glanced around and noticed other creatures stopped at the water’s edge, on the rocks, hesitating to plunge into the rushing ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt46.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("stream. Toby slid into the water and began paddling across, head held high. The current was strong and took him off course and downstream. He paddled harder. Luckily it was not a very wide gully and his front paws soon struck bottom on the other side of the foaming whitewater. They were through. Andi turned and tried to look back but couldn’t see anything. Toby was scrambling and scratching now to climb out of the gully up the rocks and mud. He stood at the edge, his sides heaving, his legs shaking from effort, and turned to look back. The flood of rainwater in the gully rushed past. Various creatures floated by, some with heads above water and some not so lucky. Beyond the gully, steam and smoke rose from the burned grass and filled the air. The rain had doused the fire. There was nothing else to see.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike slid off the fox and put Barkley down, patting him. “That’s a good boy.” Barkley stayed by Mike, watching him quietly. Mike wiped his hands on his jeans and then slicked his wet hair back from his face. He squeezed his eyes closed and opened them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Are you alright?” he asked, looking at Andi and Toby. The fox nodded. “Yes, but I don’t see Tony and Jo, do you?” Andi was recovering quickly from their wild ride, rubbing her eyes one last time. She looked downstream.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“No, but we should follow the gully that way. The current must have carried them, but I’m sure they made it across. Don’t worry, my mate is a fine swimmer. Come along,” said Toby, and he began to trot along the bank of the gully.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Are you thirsty? Here, have a drink.” Mike held out his water bottle to Andi. She shook her head and just stood looking at him. He cupped his hand and poured a little water into it for Barkley who lapped it quickly. Mike took a quick drink, capped the bottle and looked at Andi. She was wet and muddy and bedraggled. Her face was pale, her eyes red rimmed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Nothing matters now except finding my brother,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’ll find them.” Mike promised. His fingers brushed a wet curl of hair from her eyes. “Don’t worry. Let’s go, Barkley, c’mon boy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony and Jo Jo dug their fingers into Tanya’s fur and held tight to her back.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("She jumped easily over the slower moving creatures, who were all hurrying to escape from the fire as fast as their legs would allow. She stopped abruptly when she reached the edge of the gully. She and her riders watched as her mate struggled to reach the opposite shore ahead of them, with Andi, Mike and Barkley on his back.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Then it was their turn, and the she-fox said, “Ready? Hold on tight, here we go!” and in she plunged. The current caught them. Tanya paddled hard into the whitewater and was making headway when a large tree branch came at them from upstream, catching the two kids and knocking them off her back. After a moment Tony popped up, gasping for air, and arms flailing, he found the tree branch. He clung on, kicking and choking. The strong current carried the boy and the tree branch until, after some time, the branch became caught up in some rocks, its journey downstream suddenly ended.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony began pulling himself hand over hand along the branch toward shallow water…and then he just lay in it, breathing hard. Finally, he rolled over onto his hands and knees and crawled up and out of the gully. “Where’s Jo?” he said out loud to no one in particular. “JOOOOOOOO!” He yelled and yelled her name but she didn’t answer. Standing up, he stumbled along the edge of the gully, following the current downstream, calling her name every few minutes. He was going to find her and that was final. He felt completely alone and sad and scared but determined to find his good friend. First running, then stopping, bending over, hands on knees, taking big breaths. Then repeat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("It seemed to Tony that hours and hours went by, but it wasn’t too long when a scan of the gully revealed something further downstream and on the other side. “What is that?” he wondered and he began running, shouting, “Jo! Jo!” but there was no answering shout. “Oh brother, now I’ll have to cross back. And I’m such a rotten swimmer,” he muttered out loud. “Where was that tree branch when he needed it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The storm water was already subsiding when he slid down the steep side of the gully and reached a point directly across from whatever it was he saw. And now he thought he could recognize her. It was Jo, but she wasn’t moving, and there was their friend Tanya, sitting beside her. The fox rose and figured right away that Tony would want to come over, so she entered the water and swam across. “Get on and I’ll take you to her,” she said to Tony. He did so, and in a few minutes, he was kneeling beside Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo had a large bruise on her forehead. Her eyes were closed. Tony knelt beside her and gently shook her. “Jo. Jo. Wake up!” Her eyes opened and she didn’t seem to see him. “Jo, I’m here,” he said, and she turned her face to look up at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hi Tone! Glad to see ya! What happened? My head aches!” said Joanne, and she sat up a little too quickly. “Whoa, I’m dizzy too. I better just sit for a bit. You okay?” she asked her friend. He nodded, too happy and relieved for words, so glad she was alright.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("He said, “Let’s sit and take it easy. And thank you Tanya for standing guard over Jo.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“You’re welcome. Looks like Jo’s going to be alright. You two are quite a sight!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("They looked at each other and grinned. They didn’t care! Just plunked down to rest. In a little while, they would think about what to do next… but not yet. Pretty soon the two young people were asleep, with Tanya lying beside them, her beautiful fluffy tail keeping them nice and warm.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Chapter 8")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Meanwhile, upstream, Andi, Mike and Barkley jogged along the uphill side of the gully. The gully, which cut across the side of the mountain, was already drying up. The water at the bottom was quiet, the rocks and broken branches and ruined vegetation revealed. Everything was covered with mud. Across the gully on the downhill side, the blackened fields lay. Way beyond the sloping fields, they could see the houses and trees of their neighborhood, untouched by yesterday’s fire.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi ran till the pain in her side forced her to stop. She turned. Mike was red in the face and Barkley stopped, panting. “Let’s get a drink.” She climbed down into the gully and knelt to drink from the stream, no longer the torrent of the night before. Mike and Barkley followed. “We have to find them. We have to keep going. They must be somewhere downstream from where we tried to cross yesterday. Was it last night? We just have to find them…”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’ll find them, I know we will. Don’t worry,” said Mike kindly. Andi looked up from drinking and said, “Thanks. I’m glad you’re with me.” Mike opened his mouth to say something. He looked pleased but just said, “Ready?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ready.” Barkley bounded up and out of the gully and turned to look at them. He was ready too. And they began to run again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("At that very moment, Tony opened his eyes. Tanya was gone. He felt funny, as if he were being watched. His hand curled around the hilt of his homemade sword which by some miracle was still stuck in his belt. He turned his head and looked up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Staring down at him from the top of the gully was a giant yellow cat, green eyes wide. Tony slowly stood and whispered to Jo as he stepped over her, “Jo wake up… where’s your sword?” He raised his sword and watched the cat, who still hadn’t moved, who just stood watching him…The cat was about a foot tall… just a normal everyday sort of house cat, but when you’re only nine inches high, that’s as big as a tiger. “Jo! Get ready, we may have to defend ourselves. Jo? Look!” He pointed up and she looked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("She said, “It’s Tiger. That’s my kitty! Tiger, get down from there! It’s me Jo! And Tony! C’mere kitty. Here Tiger kitty!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Jo are you nuts! He’s practically twice as big as us and a carnivore!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Tone, he’s my cat. He knows me. I won’t let him eat you! What’s he doin’ out here? Maybe hunting field mice? I know there’s no one at home feeding him. He must be hungry.” And with that, the cat jumped down in one graceful move and was lowering his head to be patted and scratched by Jo. His eyes closed, and purred loudly. “See, he loves me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Whatever you say, Jo. Hi Tiger, nice kitty. Please don’t eat me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Upstream, Andi and Mike had stopped for a breather. They climbed down into the gully for another drink. Mike wiped his mouth and looked around. He saw something moving further down the gully on the edge of the water but couldn’t make out what it was.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What’s that? Let’s go see.” Slowly they approached and now could see what the commotion was: a ball of kicking legs and flapping black wings rolling around in the mud on the side of the stream.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt53.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('p', {
    staticClass: "InDent-Txt"
  }, [_vm._v("“Hmmmmmm…Seems to be a bird caught in a net. What a mess, poor thing. Let’s see if it will let us help,” Andi whispered, and she approached slowly, speaking softly, “There, there birdie. Take it easy, I only want to help you.” A shiny black eye looked at them from inside the ball of netting. Andi began trying to loosen the netting from the bird’s legs and wings. The bird continued to kick and flap, which was not very helpful.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Cut it out! You’re making it worse!” Andi complained.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And the bird replied, “Is that you Andi? It’s me, Luke. Remember? You flew with me to the top of my pine tree.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi’s mouth opened in surprise and then she grinned and said, “Of course, hello! Hold still now and let us work on this netting.” The young crow stopped struggling. That made it easier for the two young people to work. Carefully they released the shiny black wing feathers, black legs, black bill and sleek head of the young crow from the tough plastic squares of net.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Eventually it was all off. The crow stood up and wobbled a bit, trying to smooth out his wing feathers with his bill.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What happened? How’d you get so tangled up?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I saw what I thought was a meal floating on top of the flood water, and when I tried to grab it, the netting caught my feet. I barely dragged myself out of the water, and I’ve been stuck here since. Thank you. I reckon you’ve saved me. Thank you very much.” And he bowed his head politely toward the children. He spread his wings and they easily reached a foot in each direction. Looking down at the children, he said, “Can I give you a lift?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("They looked at each other and shouted, “Yes! But maybe you need a little rest first after all that struggling with the net. What do you think?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Why, that’s very thoughtful of you. Who’s your friend, Andi?” asked Luke.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh sorry. This is Mike and his dog Barkley. Mike, meet Luke,” said Andi.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("She continued, “All my life, I’ve dreamed about being able to fly. I love it! Oh, but can you take all three of us at once?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I think I can do it. Climb on!” said Luke. Andi climbed on and settled just behind the crow’s wings. Mike lifted Barkley up to her and she held him tightly while Mike clambered on right behind her. He took the dog and said, “Ready!” Andi looked out over the shiny jet-black feathers of Luke’s head, and then down at each wing as he spread them. They felt him tense and push off as his strong wings lifted them. The rocks and gully became smaller and smaller as they went higher. “Which way do you want to go?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That way,” Andi leaned down and pointed south, downstream. “Follow the gully please!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The girl’s hair streamed out behind her as she took in the view. Spread out fifty feet beneath her were the mountainside, the burned fields, and further off, her neighborhood of neat little houses, green squares of lawn, her own home and garden. But there was no one moving about.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Flying was exhilarating and exciting! She loved every minute of it. But first things first. Looking down, she began searching for anything moving along the gully. From up here the gully looked like a crooked gray line that someone had gouged across the mountainside, a silvery thread of water barely visible down the middle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike’s nose was itchy because Andi’s hair was blowing in his face and tickling him. He looked down over her shoulder. Wow, he never thought this would happen in a million years! He wondered what Barkley thought about it. He leaned into Barkley’s neck. The dog responded with a lick.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And so, after a while, Andi screamed out, “There’s something there! I see them, I see them! Luke! Put us down there! Please!” And so he did. Jumping off, the girl ran to her brother and hugged him hard.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Andi, you’re going to suffocate me. Cut it out! What’s all the fuss? Wow! You flew on a crow again! Cool! Can Jo and I have a turn? I’m hungry, got anything to eat?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The four young people lounged on the rocks, relaxing in the warmth of the September sun. Andi and Mike wanted to hear Tony’s story of what happened after he was swept off Tanya’s back. Joanne shared that she couldn’t remember much at all about what had happened to her. Mike and Andi didn’t mention how worried they’d been. The four friends just gazed at each other, making jokes and laughing, happy that all was well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Finally, Tony said, “This is great, but are we going to eat? Aren’t you all starving? I am!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi stood at the edge of the stream, all that was left of the rushing flood water. She said, “Look at these tiny fish! Minnows! What if we caught some?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yuck! Bleck! Who wants to eat raw fish!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Lots of people do. Haven’t you ever heard of sushi? But we could cook them,” suggested Mike.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Well, we could make a fire.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“A fire? We have no matches!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I have this…” And Mike pulled a red lighter out of his pocket.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Why do you have a lighter, Mike?” asked Tony, green eyes wide. “Do you smoke?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Nah.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Are you thirteen?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Who’s askin’?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Just me, Mike. Tony.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yeaah, I’m thirteen. And I don’t smoke. Cigarettes are bad for ya, don’t you know that? They stink. I have tried ’em though… tasted terrible and made me dizzy. And I have the lighter because…well, I saw it sitting there on the coffee table and I wanted to try it so I took it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What would your dad say?” Tony wanted to know.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“He won’t care, he’s never home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Where is he?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“At work. I dunno.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What about your mom?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“She’s at work, she’ll never know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What about your big sister?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“She’s out with her friends all the time. It might belong to her, or to one of her friends.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Gosh, it sounds like you’re alone a lot!” said Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Gosh, you ask a lot of questions!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Well, it’s just a good thing you have Barkley for company, that’s all I was thinking,” said Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike thought Tony wasn’t so bad. He was Andi’s kid brother, after all, he must be okay. Just nosey. He wasn’t used to so many questions or having anyone care to hear his answers about whether he was lonely or smoking cigarettes or taking things that didn’t belong to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Never mind about minnows, we could ask Luke to fly us home,” said Jo, jumping up with a big smile as she thought of home.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“No, we can’t go back. We’re on a mission. But we could ask Luke to take us on a quick detour to Southside Farm so we could find something to eat. Its harvest time so there’d have to be something…apples, grapes, sunflower seeds…that sort of thing. Replenish our stores for the trip through the woods.” Andi sat looking serious as she contemplated the immediate future.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Andi, why don’t we just fly to the Arch?” asked Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Because I think we should keep out of sight and not arrive in such a visible way. I’m not sure why, that is just my feeling. You know, my intuition? Mom told me to trust it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Agreed. What’ll we eat in the woods?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Pinecones and acorns?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo chimed in, “Native Americans ate acorns. They pounded them into flour and made pancakes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“You know your history, Jo!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Maybe. I’ll try ’em if I have to. But let’s do go to Southside Farm and stock up. Besides, maybe we’ll see someone we know. ANYONE would be great to see! Luke, do you have any friends that could carry Tony and me?” asked Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Of course,” said the crow. I have a whole family…oh gee, I hope they made it through the fire and storm okay. I better go check, but I’ll be back, and we’ll give you a ride to wherever you want to go. I owe you a big favor! See you tomorrow then.” And he flew back the way they had come.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("Chapter 9")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("For a while, the children remained in their camp in the gully, their backs to the banking, the trickling stream before them. As the light of the day began to dim, Mike suggested they collect sticks and he would make a fire. “Oh boy!” said Tony excitedly, and he jumped up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Wait for me, Tones! We better stick together,” said Jo, and they went off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi walked along the water slowly, picking up dead sticks in a dazed sort of way, dreaming of flying with the birds again. Mike made a kind of pit in the center of their camp and ringed it with stones. He lit the sticks the others had collected, and soon they watched the small fire grow into a big orange blaze with sparks rising into the night sky. Admiring Mike’s skill, staring into the flames, no one really remembered the terrifying fire of a few nights before. This was ever so much friendlier, warmer, cheering them up, as only the magic of a campfire can.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“If we only had some marshmallows,” said Andi, and they all burst out laughing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Or hot dogs,” Tony added. Turning to Mike, he said seriously. “We never got to hear your story, Mike. Why were you coming down the trail that we were going up? How lucky we were to meet up with you!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike was stretched out on his back with one arm under his head, the other wrapped around Barkley whose head rested on Mike’s chest. “I was headed to my grandmother’s place. She lives on the other side of Stone Mountain, across the river. Going through the grass was a shortcut. I thought maybe my mom might be there. Or my sister. I remember I was alone at home, lying on the sofa, watching TV with Barkley. When I woke up, we’d been shrunk! I couldn’t believe it. After a while, I realized I couldn’t just stay there and wait, not knowing what was going on. So I left. And that’s my story. Why were you guys going up the trail?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi answered, “I think we’ll find the answers to our questions at the Arch Monument. We were headed up the mountain. I’m so very glad we met up with you. Will you come with us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yeah.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hurray!” Tony yelled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike grinned at him. He liked these kids. Being with them was much better than being alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Later as they drifted off to sleep and all that was left of the fire glowed in the ring of stones, Tony laid back and looked up at the sky. He thought about Mike. He was a little bit in awe of Mike. And he trusted his sister’s intuition, or whatever it was, and his friend Jo’s spunk and good humor. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("We have everything we really need to solve this mystery")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(", he thought. He was sleepy and happy now that the little group was back together again. As his eyes were closing, he thought he saw some tiny blinking lights in the sky, red and green and white, zipping first in one direction, then another…Were those lights tiny because they were far away or were they just tiny? ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I must be dreaming already")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(", he thought and fell asleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("With a soft whirrrr and quiet clicks, like the sound of a camera shutter, a small silvery drone spun overhead, lights blinking and pausing above the sleeping children. It hovered in place, spinning and blinking, and then quietly rose into the sky and headed up the mountain toward the Arch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi awoke to a slight noise. A flock of crows had landed lightly nearby. The shiny black birds watched and listened with interest as Luke hopped up and spoke to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Good morning, Andi. I’ve brought my brothers and sisters to take you to the farm. Are you ready?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m ready!” she said. “Guys, wake up! Time to go!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi rode with Maya, one of Luke’s sisters. In the air, Maya swooped and soared while Andi clung to her back and squeezed with her legs but not too tight around the crow’s body. The girl’s hair lifted in the breeze. She shivered, not from cold but with excitement and happiness to be in the air again. Seeing her neighborhood from a “bird’s eye view,” she suddenly swallowed hard and her eyes blurred with tears. She found that she loved it, every field, every country road, every patch of woods, the school, the homes and barns, all of it. Her home. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("We will fix this")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(", she thought. ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("We can do it")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(". She looked back and saw Mike and Barkley atop Luke’s back, the bird’s strong wings pumping. Such a beautiful creature. The three of them made a sight she would store in her memory to be treasured and recalled with happiness for the rest of her life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony leaned over so far to see his house and backyard that he almost fell off his crow. He thought he saw his bike. He loved it. Red Stingray with banana seat. So fun to ride to school and to baseball practice and downtown to get an ice cream. Bike riding was one of his favorite things. There was the little league field behind the school and beyond the playground. He loved baseball and being on the team. “Gee, I hope we’re all back to normal in time for baseball season.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo Jo saw her family’s camper parked in their yard next to Tony’s driveway. She really loved that her family and his family were neighbors. The three kids enjoyed sleeping out in the camper on hot nights, playing cards and music on her little portable phonograph player. Her favorite song lately was the Beatles’ ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I Want to Hold your Hand")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(". So cool! She learned a lot from her two older brothers. She missed them very much and wondered where they were. She hoped she could talk to her brothers very soon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike looked down with interest as they flew off the side of the mountain and across the neighborhood of the three other kids. “We’ll have to pass over my side of town on our way out to the farm,” he worried. He watched as the look of the town changed. The houses were smaller and some were dilapidated. More old cars sat in the yards. Dogs on chains lolled out of their doghouses and the ground around them was bare. This is what they call “the other side of the tracks”. He thought to himself, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It’s not our fault. Dad works so much he doesn’t have time to fix anything. Mom too. She’s too tired when she gets home to do much except watch TV. And some dads are just not as handy as other dads. ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike could see this was true even though he was mad at his dad for not scraping and painting the peeling paint on their porch. He looked around at his friends and saw that they were not seeing what he saw. Not judging him. And he was glad of it. Barkley nudged him at that moment. Barkley was so smart. He always knew when Mike needed a cold nose nuzzle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“As the crow flies” it was not a long flight across town to Southside Farm. Spread out below were the fruits of a New England farm at the peak of harvest, but there was no one to harvest them. Fields of corn and pumpkins and hay, orchards full of apples, gardens and grape vines, beehives…The barns and pastures stood empty. Where were the animals? The hayfields were unmowed. No chickens clucked in the yard. The horse drawn cart Mr. Southside used to deliver eggs was parked by the side of the barn.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Set us down over there please, near the grape arbor.” The deep purple sweet smell of ripe Concord grapes hung in the air. They tried a few.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s fly to the orchard for some McIntosh apples.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s go in the barn!” They squeezed through the crack under the big doors and stood looking down the main hall of the barn. It was shadowy and quiet, smelling sweetly of hay and faintly of horses and cows… Walking down the long main hallway on the well swept wooden boards, they passed empty stalls, hanging harnesses, and tools for raking hay. High overhead was the hayloft. “Hey, look at us!!!” Jo and Tony were walking along a beam overhead. “We’re going to jump down and land in the hay! C’mon with us!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Don’t land in the water trough, Tone! You can’t swim!” But right then Mike and Andi heard some slight noise, and looking around they saw a mouse coming toward them with a mouthful of grasses. The mouse dropped her load of grass and a little hesitantly said, “Hello.” The two kids said “hello” back. She was a deer mouse, brown with a white belly, four dainty white feet, and large brown eyes. She said, “This is a very busy time for me. I have to make my nest and gather a store of food for winter. It’s coming, you know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes, we know,” said Andi politely. “We don’t mean to interrupt. But where are all the animals?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I don’t know. One day they just disappeared. As if they evaporated.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Strange. Did you see anyone or anything around when it happened?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I thought I saw some blinking lights.” Just then they were interrupted by a loud “Yahoooo!” and Tony jumped into a pile of hay, followed by Jo. They slid down to the floor and brushed themselves off, laughing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Goodbye Mrs. Mouse.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Goodbye children,” and she hurried off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Back in the barnyard, Mike said, “We need to move on. What about those sunflowers? Let’s get some seeds and stuff our pockets with them.” They shimmied up the stalks and collected enough seeds to last a long time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Now that we know Mike has a lighter and we can make a fire, let’s get a few peppermint leaves so we can have tea,” said Andi.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“With honey? Yum,” said Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’d rather have hot chocolate,” piped up Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I like coffee myself. Black, no sugar. That’s the way my dad drinks it,” said Mike.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yuck! You’re crazy,” said Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo giggled. “Tones, we all have our own likes and dislikes. I don’t like tea or coffee. I like milk. Or juice.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“C’mon, you like hot chocolate don’t ya?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes I like that too!” said Jo. “You just have a sweet tooth, Tone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yup, right here, see it! And proud of it!” And then there was much laughter and fooling around.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The sun was high as they readied to go. “Where exactly do we want to fly to now?” asked Jo. She had a way of asking what everyone was thinking.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony said, “It’s so beautiful out today, so sunny and warm, and we have this wonderful transportation. Let’s fly to the pond and go for a swim!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yay! Hurrah! Yes, let’s!” and so they did.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The afternoon passed slowly, the youngsters splashing each other, floating and diving and lazily practicing their backstrokes. Tony thought to himself, “")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Ahhhhh, this is the life!")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("” as he floated on his back, gently sculling along with his hands at his sides, his feet kicking now and again. This was all he really knew how to do in the water, not like Andi who was a strong swimmer. The water was incredibly warm. A few clouds drifted across the blue sky in small white puffs like cotton balls… which morphed into popcorn. And then into dinosaurs. He thought, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Normally we’d be in school on a day like this")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("! This was true. There were some advantages to their situation: adventure, excitement, talking animals, flying on the backs of birds. Swimming at the pond on a sunny day. He lifted his head to see what everyone else was doing and suddenly realized he’d floated on his back way out over his head! Unaware of what he was doing but very aware that he could not swim!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hey guys! I’m out here! Help!” And Tony started to splash and kick and gulp the air, awkwardly trying to crawl with his arms, so worried that he forgot to roll over and rest on his back. But Mike saw and heard, and in a flash was on his way out to meet his struggling friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hey, take it easy little buddy, you’re fine, I gotcha.” Mike jackknifed underwater and came up behind Tony, gently pulling him onto his back with both hands under Tony’s armpits.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“There ya go, just put your head back and relax!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi was soon at their side and said, “I can take a turn.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike said, “No this guy ain’t heavy, it’s no sweat!” And so the three of them continued in to shallow water.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo came wading out to join them. “Gee Tone, I’m sorry I wasn’t paying attention. I was down at the end of the beach where all the lily pads are, there are all kinds of frogs and snails and stuff over there. Are you alright?” Tony was fine, just a little embarrassed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Tones, you’ve got to go back and finish those swimming lessons!” his big sister said, and they all laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The little group relaxed on the sand, and chatted to the crows who were smart and funny companions. Andi heard Tony say, “We know what our mission is and why we need to stick together and accomplish it. Right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Right!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yeah! Let’s go!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ruff-ruff,” Barkley barked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We veered off course through no fault of our own,” said Andi. “But now we need to get back on track. People we love are counting on us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How do you know?” asked Maya.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi thought for a minute. “I dunno. Just… I think we can do something and we have to try. Where are our parents? What’s happened to them? They would never abandon us. Something has taken them and we need to get them back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("They mounted onto the crows one more time. Andi gave directions to Luke and Maya. They knew exactly where she wanted to go: right where the field of grass ended and the woods began. It was the crow family’s home territory. Once again the children flew over the familiar landscape. Yet it seemed brand new when seen from way up high. It was spectacular. What a day! The end of September was a lovely time of year. The weather was fine, but soon the nights would be chilly and then downright cold. They had better be going.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi marveled again at the crows in flight and felt sad it had to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Delicately and with much deft precision and coordination, all the while making it look so easy, the crows circled and touched down, and the kids hopped off. Luke eyed them. “We’ll keep a watch out and try to get word to you if we hear anything,” he promised.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony said, “We may need your help later when we figure out what to do.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Goodbye and thank you. It was a pleasure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We very much appreciate your help today,” said Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Thanks a lot, it was great!” said Mike.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Caw! Caw! Take care and watch out!” The big black birds lifted off and soon were away over the trees and gone.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt69.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("Chapter 10")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The four companions stood together and watched their crow friends fly away. The warm day of harvesting and swimming had tired them. Looking back, everything seemed peaceful over the sloping grass. They turned to the woods, and the path which they knew well invited them in.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s go a few steps in, okay? I think we’re too exposed out here,” suggested Mike. “A bit off the path would be good, too.” He added with a wink, “Ya never know who’ll be coming along.” His friends grinned at that and followed him in. Stepping onto pine needles, they made no sound. They smelled the clean pine scent and felt cool in the shade.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Leaving the path, Mike moved beneath the underbrush of hobble bushes and young moose maples until he found a good spot. Late afternoon sun slanted in here and there and kept it from being too gloomy. Each young person looked around for a resting place. Thick mats of green moss would be their bed tonight. First they sat around eating sunflower seeds, talking quietly. Then they patted Barkley and told him what a good dog he was. Finally they curled up to sleep their first night in the woods.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("In the morning they awoke and looked up to see something beautiful. It was now the end of September, and the high canopy had transformed into brilliant color. In between the green pines, maple trees were scarlet red all over. Some trees were red, yellow and lime green. Coppery oak leaves shone in the sun. And the underbrush blazed orange and yellow and gold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi sighed and said out loud, “It’s so amazing! How does it happen?” not really expecting any explanation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Her little brother hopped up and cleared his throat. “I can tell you why the leaves change color in the Fall. It’s because of changes in the length of daylight and changes in temperature. Colder and darker, basically. The leaves stop their food making process. The chlorophyll breaks down and the green color disappears. The leaves show their true colors. Neat, huh?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo admired her friend and asked him, “The leaves’ food making. Is that the “photosynthesis” stuff we learned about in biology?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony agreed, “Yup. Sunlight, water, carbon dioxide and chlorophyll convert to chemical energy”----")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh Tones, you’re amazing!” interrupted his sister. “Here’s a scientific thought. The colors remind me of red, yellow and orange Trix cereal.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Sweet!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yeah, really.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I never noticed it much, but now that you mention it, it is pretty spectacular,” admitted Mike.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What? Trix cereal?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“No, ha-ha! The scenery!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("With that, they got ready to move out. For now, they would walk the path. The path followed an old wall of gray stones tumbling down, covered with circles of pale green lichen. Little polypody ferns grew on top like green hair on gray heads. Andi was tickled by that name “polypody.” The wall ran through the woods, a relic of long ago fields and farms and forgotten settlers. Being children, it was of course necessary to climb the stones and walk atop the wall. Jumping from stone to stone, which is a little harder to do when you’ve been shrunk, they leapt over the red leaves of poison ivy that crawled over the wall and ignored the dark purple berries of deadly nightshade.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Don’t eat those!” and Andi pointed to the nightshade berries.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How do you know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Mrs. Northstar showed me. She’s really smart about birds and plants and stuff. She let me look through her binoculars and she gave me this cool little thing.” Andi pulled a 10X out of her pocket. “It’s a magnifying glass called a 10X. When you look at something really close up, it’s like looking at another world. Try it.” And she handed her 10X to Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo knelt down on some moss and looked at it through the 10X. “Wow,” she said, with her nose to the rock. “Moss is amazing when you see each tiny plant up close. Beautiful! Cool!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Everyone took a turn with the 10X. Tony inspected the tentacles on a slug. Mike examined the ridges of the skin on his fingertips. Is it really possible, he wondered, that every single person on earth had their own set of fingerprints and no two were alike? Chipmunks popped out from between the stones to see what was going on, and so did a weasel, who simply stared for a few seconds and then took off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The friends snacked and played on the wall, in general just enjoying being alive. Being free. Not in any particular hurry to get anywhere. Taking time to investigate little side trails and peering into secret leafy hollows. Happy together, they made some progress and eventually found themselves deeper into the woods. Jo asked Mike, “Do you think we could have a campfire tonight Mike?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Sure!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh boy!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And so they did. That night there was a full moon that was so bright the trees made long straight shadows across the floor of the woods. The campfire lit up the faces of the four children, who sat leaning back against the mossy stones.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Someone asked, “What shall we discuss tonight?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ahhhhh…”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I know. Our favorite things! Call out your favorite thing!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Pizza!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“A good book!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“My dog!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Awwwww… The Beatles!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes!” What else?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Watching TV on Saturday mornings!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Swimming!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Riding my dirt bike and eating a hamburger!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Hey that’s two things!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Playing soccer… and scoring a goal!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Round and round a few more times they went until they got sick of it. They sang some silly songs and told some funny stories, until finally they were quiet and just sat contentedly, watching the fire die away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony summed up the evening, “We really know how to have a good time.” He yawned. “Good night everybody.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony closed his eyes and opened them again to see the stars overhead. He imagined ferocious animals living in the woods around him, bears and boars and bobcats. What were they all doing right now? He pictured a big steaming plate of Chinese pie and wondered why a dish of hamburger, mashed potato and corn was called Chinese pie. His mind wandered to thoughts of erupting volcanoes and fiery hot magma (who thought up that funny word “magma” anyway?) and drilling down to China to the other side of the world, and seeing the dinosaurs stuck in the center of the earth on the way through. He thought about having fried clams and foot-long hot dogs on Friday nights at the drive-in clam bar with Grampa and Grammy. He loved his grandparents. He felt their love and fell asleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo felt content with her friends close but she missed her two big brothers. They’d sit next to her on the couch when she’d be trying to watch TV, one on each side of her, and they would play with her hair and tickle her till she had to run out of the room calling Mom! Mom! And they’d laugh and stretch out across the space where she’d been sitting. But she missed their goofiness and handsome faces. Randy liked soccer and had a girlfriend already. Matt liked cars. Were they shrunk too? And she missed her cat, her yellow Tiger kitty. She imagined she felt the warm weight of Tiger curled up in her lap. Comforted, she fell asleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike was lying there asking himself, “What comes after this crazy adventure?” He liked these kids. They didn’t think he was stupid and slow. They didn’t yell at him. He really didn’t want this to end. Except he did miss his mom. He loved his dad too but he and his dad were so complicated! And his sister…why did she have to be so mean? He swallowed and then remembered how much he loved riding his dirt bike. And he loved taking it apart, carefully laying out the gears and chains on the concrete floor of the garage and cleaning off the grease. Reattaching and tightening with a turn of the screwdriver and the clicking of socket wrenches. Starting the engine to hear it sputter and hum. Rubbing his hands with sweet smelling turpentine to clean off the black grease. Still having black under his fingernails at the dinner table. He was almost asleep when he remembered shoveling white snow off his grandmother’s steps. She came out and smiled and thanked him and then they went in together for some pie. She loved him, he could tell. And he her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi was still thinking of her favorite things and remembering the long drive to the seashore and finally getting there and running into the cold-cold water and lifting her arms and feeling her body rise up in the surf as she jumped the waves and tasted the saltiness on her skin and then lying on the fine warm sand. Andi loved to put a blanket on the grass in her backyard and lay on her belly and read. When she tired of that, she’d roll over on her back to watch the clouds float by. Then she’d lay on the grass in a patch of clover looking for lucky four leaf clovers for hours and hours, and she’d press them into her books. Sometimes her friends would come over and they’d sit on the blanket with her and play with their dolls. But that was years ago when she was little and she really didn’t play with her dolls much anymore, but she still had them and liked to look at them in her room. And sometimes she and her friends would get more blankets and throw them over her mother’s clothesline and make a big square tent and eat peanut butter and jelly sandwiches inside where no one could see.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("But she was older now and liked listening to music with her friend Annie in Annie’s room on her silky yellow comforter along with Annie’s dog Spot. Annie had a little white painted dressing table with a mirror in her room and a bed and bureau that matched. Andi liked that. She hoped Annie was alright. She thought about what it would be like to be Robin Hood. To live in the woods as a daring outlaw, much loved by his band of men and people of the town, always rescuing somebody and escaping on a fast horse and wearing green tights, ha-ha! Robin Hood was her hero. Was that because the actor who played Robin Hood on TV looked like her dad? Maybe. With that happy thought, she fell asleep.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("Chapter 11")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("A string of good weather days followed in which the four young people at times marched, at times dilly dallied, along the path, enjoying their freedom in the woods. They felt independent and strong, their senses sharpened. Two boys and two girls had become a team, taking turns leading, being on watch, and doling out daily tasks, which were mainly scouting for water, food and the next campsite. In between there’d be contests and mock sword battles while balancing on the wall. Someone would say “watch this” or “can you do this?” and do cartwheels and handsprings on the path, and games of hide and seek were played that would lead to calls of “Hey come look at this!” Sometimes someone would jog up the path alone and later come running back out of breath to report what he or she had found up ahead. Jo laughed and said she would write a book someday called “101 ways to prepare acorns.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("It was now about mid-October. Leaves had begun floating down, silently, leaving bare branches backed by a sky of clear cold blue. The path became a yellow necklace of leaves. The kids trudged along, kicking up the leaves, enjoying the sound of swish, swish, swish, swish. Now and then they’d see sunlight hit the bark on a slim white birch tree. The path wound under wild grape vines, and just for a second they smelled grape jelly. Brown vines of bittersweet dangled from the trees. These vines were strong and proved to be very fun to swing on. Everyone took a turn, yelling and whooping pretending to be Tarzan, flying off into piles of leaves or more skillfully setting down on the wall or a branch, ready for another swing. The noisy activity attracted the attention of the woods’ animal residents, who’d come closer to watch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The children stopped playing around and spent time chatting with a porcupine, who explained that no, porcupines don’t shoot out their quills, but the quills do dislodge very easily when touched. And several young deer the color of caramel talked of how happy they were with the large crop of acorns that year. Rabbits, woodchucks, squirrels, an opossum. The creatures seemed to know all about the four friends and their mission, and the children were happy to learn from the animals. Luke and Maya would settle on the branches above and call out noisy greetings to their small friends below. The little gang of titmouse, nuthatch, chickadee and downy woodpecker fluttered down to the lowest branches to see the goings on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("In the evenings, as Andi, Mike, Tony and Jo sat around their campsite, they’d hear rustlings and cracklings and know something was approaching. Then they’d see the eyes gleaming of a black and white skunk or raccoon with banded tail who they hadn’t yet had the pleasure of meeting, and they’d introduce themselves and share what seeds or nuts they had and ask, “What news?” Or their fox friend Tanya would check in with them on one of her nighttime hunts. Up in the trees, the barred owls would look down on them and call out, “Whoo whoo who whooo!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("At the close of one such day, after an afternoon of scrambling up trees and swinging on vines and landing in piles of leaves, Andi plopped down and asked, “Mike, when will you be fourteen?")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt79.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "InDent-Txt"
  }, [_vm._v("“Next spring, at the end of April.”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Wow, fourteen,” thought Andi out loud. “Do you ever get the feeling when you turn a year older that you were waiting and waiting to be the next number until suddenly you are a year older and the new number, but the NEXT bigger number seems MUCH more interesting and you want to be that old instead of the age you are? I do. What do you want to be when you grow up Mike? Do you know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike thought about it and then said, a little shyly, “I want to have my own garage. I want to fix cars for people and do a good job and not charge too much so people will know I do good work and will keep coming back so I’ll always have plenty of customers. But I need to save money to buy my garage. A lot of money. So I have a job after school, helping at Clark’s garage.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo said, “That’s super, Mike. I would trust you to fix my car anytime. Andi, what do you want to be?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Well,” replied Andi. I like lots of stuff. Animals and being outdoors and reading. I don’t know yet how I’ll make a living when I’m grown up. I hope I get to study lots of things and visit other places to see what I really like and then decide. What about you, Jo?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh,” Jo said with confidence, “I want to be a professional soccer player and win the World Cup. And then be an oceanographer. And maybe play in a band. Can a person be more than one thing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Of course!” Tony jumped in. “I’m thinking of being a space scientist. But I also love dinosaurs and rocks and bugs and funny TV shows. I’m too young to think about it yet. I’m just happy finding out about all the interesting stuff in the world.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi continued, “One thing I’ve noticed is that if all people speak different languages, then it’s hard to communicate. So maybe I’ll learn some other languages.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That’s great!” exclaimed her brother. “It would be good if, when I dig all the way down to China and pop out of the ground, I could speak Chinese.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ha-ha! Oh Tone, you’re so crazy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What’s crazy about it? By the time I grow up, scientists will be going EVERYWHERE and doing EVERYTHING. That’s why I want to be a scientist.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Well you’ll have to study and do homework you, know.” warned his sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I know. I’ll get through it somehow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Everybody chuckled at that. And they all ate a few small, withered apples, a little shriveled but still sweet, from an old apple tree. And some black walnuts. Quite a treat, a nice change from acorns and milkweed in Tony’s opinion. Luckily they hadn’t started a fire this night which they didn’t do every night to conserve the fuel in Mike’s lighter, because overhead there was suddenly a rush of little lights all heading in the same direction they were, but stopping now and then to hover and blink over the woods, as if searching for something. So the four children watched quietly, laying low, and were reminded of why they were there and what their mission was, and that no matter how fun and enjoyable it was to be free and together and playing and laughing in the woods, they had to keep moving on towards their destination and find the answers to their questions. And with the exception of Jo, whose turn it was to take the watch, they all finally fell asleep with those serious thoughts on their minds.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("Chapter 12")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Next morning began with a bird. The nice clear song of some sort of thrush. “")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Beautiful, like a flute,")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("” Andi thought, before she even opened her eyes and sat up. Eventually she stood and stretched and looked around for a glimpse of the bird. There was some fluttering above her, and then the birdsong came again but from further off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Awww, shucks, I missed it.” She said this to herself as she noticed her beloved companions laying nearby, still sleeping. She smiled at them and then looked at the woods around her. The beauty and incredible diversity of the plant life around her beckoned. She started wandering along little brown pathways carpeted with needles and strewn with acorns. There were bunchberry and carpets of wintergreen, big brown mushrooms pushing up through the moss, and those weirdly white Dutchman’s pipes. These were just a few of the plants down on the forest floor, beneath the underbrush, which in turn lay beneath the high canopy of the giant oaks and maples and pines. She felt in awe of Mother Nature once again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi thought, “Mid-October means cool days and cold nights. All their coats, hats and mittens were at home upstairs in boxes. “I wonder how we’ll manage that one?” she spoke out loud. There was no reply, just silence. She shuddered to think about it. “I better get back to my gang,” and she turned around to go back. Her left foot seemed to be stuck under something as she tried to lift it, and then “SNAP” she was grabbed and lifted and swinging upside down from one ankle, caught in some sort of snare! Screaming, she swung, kicking frantically and finally reaching up to try to free herself from the tight noose around her ankle. The effort was too much, and she let go, swinging upside down. “HELP! GUYS HELP ME!” she yelled. Panicking, she thought, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("What if they don’t hear me")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("? “Toneeeeee! Mikeyyyyyyyy! Joooooooooo! HELP!!! She yelled and yelled and then strained to hear any reply. Her head was starting to feel funny and her heart was racing. After what seemed like forever, she heard something. They were calling her name. “Over here!” she called as loud as she could.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Where are you Andi?” At last the three of them were there below her, searching in all directions but not above their heads. Only Barkley looked up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m up here!” she shouted. Barkley barked, and the three kids on the ground looked up in unison, their mouths open in shock.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“You three look rather comical like that, but I’d really like to get down from here. Any suggestions?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi was dangling from a cord tied to a tall, very thin sapling that had whipped up straight after she stepped into and released the snare. Mike and Tony looked at each other and said at the same time, “Let’s climb!” So they jumped onto the sapling and began to climb hand over hand up the thin stem, legs wrapped around monkey-like. “Great minds think alike, huh Mike?” grunted Tony. “Yup!” laughed Mike. The sapling began to bend under their weight as they neared the top. Their efforts caused Andi to be lowered closer to the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hey Andi, what about that famous jackknife of yours? Still got it?” In her panic, she’d forgotten all about it. Hanging upside down, her head feeling full and pounding, she slipped her hand into her jeans pocket and pulled out the jackknife. Opening it, she curled herself up and grabbed the cord at her ankle and began sawing at it with the knife. Eventually it snapped and she was now hanging on by one hand, right side up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Look out, here comes the knife JO!” and she dropped it. Jo scooped it up and backed away, pulling Barkley back with her. “Go for it, Andi,” Jo called.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi let go. “Tuck and roll, tuck and roll,” she repeated to herself as she hit the forest floor, surprisingly springy with moss, but still a jolt. What made her think of the tuck and roll advice? Gymnastics? She didn’t recall, but it definitely helped take some of the sting out of her landing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Nicely done, Sis!” Tony cheered as he slid down. Then Mike hit the ground beside him. The sapling stem had sprung up to the sky now that it was free of their weight. Mike grinned, “Caught in a squirrel snare? What next! Quite a surprise, I bet, huh Andi?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Geesh, I guess,” Andi replied. “Thanks guys, for rescuing me. Can we sit down for a minute? I feel a little woozy. Must be all that blood rushing to my head making me dizzy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("She dropped down cross legged. Jo held out her jackknife. “Here ya go. Good thing it was still in your pocket!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike said, “Andi, I hate to make you get up, but we should move away from here a little way just in case whoever set this snare comes along.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony said, “In all the years we’ve been playing and running through these woods, have you ever seen such a thing? I haven’t.” The four friends trudged back toward camp. Spotting a fallen log, they climbed up on it and discovered that it was covered with soft green moss. They lounged on it, enjoying its softness. “How did it happen?” Tony asked Andi.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I don’t know, I was just turning my feet around and then Snap! I was hooked and flying upward. I guess I panicked because I forgot all about the knife in my pocket Thanks again for rescuing me. Wow, was I glad to hear you answer my calls. Screams actually,” she admitted, rubbing her ankle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“You’d do the same for us, I know” said Tony. “Glad to have you back, Sis!” and he punched her shoulder playfully, but it still hurt. “Owwww,” she complained, but with a smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hey, do you hear something? A regular thudding sound?” Jo kept her voice low.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“No, but I feel the ground shaking, something’s pounding its way toward us, we better hide and quick!” They ran down the length of the log, jumped off, and crept into its hollow end. Peering out, they waited to see what giant was coming toward them, making the ground shake. A regular sized adult person? But who? All the other adults they knew had gone missing. Someone or something was approaching.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Peeking out from the open end of the log, the four kids stared at a large old man stumping towards them through the crunchy leaves. He had a black knitted cap on his head and a fringe of white hair. Grizzly whiskers covered his face except for a red nose, and bushy white eyebrows shaded a pair of dark eyes. He wore a ragged red and black hunting jacket and green jeans with patches. He looked thin but wiry and strong. He grumbled and cursed as he knelt to gather up the remains of the rabbit snare. The old fellow squawked with surprise as he examined the cut ends of the leather cords. Quickly he looked around, crouching and muttering.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike whispered, “I’ll be darned. That’s old Henry Hyde…hermit, misfit, sort of a lost soul.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How do you know?” whispered Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("In a very low voice, Mike replied, “He used to work for the town doing odd jobs. He kept the fires going at the town dump until it closed and the town changed the way they dispose of our trash. I haven’t seen him since. I didn’t know he was living in these woods, did you? Never saw him here before.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Nope,” said Tony, “and we play here all the time. Look, he’s getting up. Shhhhhhhh…”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Henry Hyde stuffed the remains of the snare into his pocket and got to his feet. He looked around once more, slowly, and the kids held their breath. Then he began to walk swiftly back in the direction from which he’d come. Four pairs of eyes followed his black and red jacket until it disappeared into the woods.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s follow him! Maybe he can help us?” said Jo quizzically.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi replied thoughtfully, “I kinda doubt that. Just a feeling. But yes, let’s see where he goes. Maybe we can find out something. Like why he is still normal size and hasn’t shrunk like us or disappeared like the other adults we know. C’mon!” Running lightly over the needle covered ground, they returned to their camp, gathered their things, and started up the path. They began by jogging but eventually slowed to a walk. After a while, they stopped for a drink and a bite to eat. Continuing on again, they trudged the path for several hours. As the afternoon came to an end and the sunlight faded, everything began to turn gray. Tony was in the lead when suddenly he turned to whisper loudly, “I see a light ahead!” The rest of the gang caught up and stood breathing loudly, straining to see what he saw.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes, hmmmm, that’s weird. The light looks high up as if it’s up in the trees. Let’s get closer… but quietly!” said Mike softly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Stepping slowly and carefully on the litter of leaves, and drawing closer to the light, they finally saw the light shining out from a big black shape high in a giant old pine tree. Andi exclaimed loudly, “A treehouse! He lives in a treehouse! Sweet! How cool is that!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Shhhh…!” whispered Mike. “How can we get up there? What about Barkley?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I can stay with him,” offered Jo. “Barkley and I will act as lookout. I can do my whistle if I see anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo was good at the two fingered whistle. When Andi tried it, she couldn’t make any sound come out.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi thought over Jo’s suggestion and replied, “Good idea. Maybe hide in those bushes?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Be good, Barkley. Be quiet.” Mike hugged his dog. “Thanks Jo Jo!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How are we going to get up there?” asked Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How does Henry Hyde get up there?” asked Mike.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Looks like he climbs a ladder, Andi replied. “And there’s a knotted rope. Probably for hauling up his groceries. Can we make it up the ladder? Maybe just climbing the tree would be easier?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m trying the ladder,” said Mike. “It’ll be a workout!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony and Andi began to climb the low hanging branches that ended in sprays of pine needles. “See you up there!” Tony called to Mike quietly, and at last, the three of them were looking into the treehouse window.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-13"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("Chapter 13")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Henry Hyde sat at a table in the middle of the room. A lantern sat on the table, along with a mug and a bowl of something, and what looked like the leather cords of the broken rabbit snare, among other things. The kids could see a small black woodstove and a rack of shotguns hung on the wall opposite their window. Henry took a bite of stew, wiped his mouth on his sleeve, took a drink, burped, and then picked up the leather strap, pondering, scratching his head.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Glancing around the gloomy cabin, the curious youngsters could make out rough board walls that were hung with animal heads. Some had antlers, some didn’t, but all were strung with cobwebs reflected by the lantern light. Dead stuffed bodies of animals stood around the room, on shelves, and on the table. Beaver and bobcat, deer, fox and woodchuck, even a black bear standing in a corner with wide open mouth revealing sharp fangs, down to squirrels, chipmunks and white footed mice. All had shiny, beady glass eyes. Stuffed owls, hawks and crows gazed down from perches above Henry’s head.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How creepy…Well, I guess we know what Henry likes to do for a hobby,” muttered Tony. “Wonder what that stew meat is that he’s eating?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Should we try talking to him? See if he knows anything that can help us?” asked Andi.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I dunno…this place is spooky,” whispered Mike. “Shhhh, what’s that noise? Get back, someone’s climbing the ladder!” Three knocks sounded on the treehouse door. Henry jumped to his feet and the chair fell over. The kids jumped. He went to the door, wiping his nose on the back of hand, then his hands on his pants. Henry Hyde opened his door.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Good evening, Mr. Hyde,” said a voice from outside. “It’s you. What do you want?” asked Hyde.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Now, now, Mr. Hyde, that’s no way to greet your guest. May I come in?” and the figure swept passed Henry, picked up the chair and sat down in it. Alas, he faced away from the children.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The kids strained to hear the conversation. “We’ve got to get in there so we can hear better,” said Mike. Tony inched over to the edge of the window. He saw a crack between two wallboards and said, “Here goes nothin’!” and squeezed through. On the other side of the crack he stepped onto a shelf and ducked behind a bottle with gold liquid that shone in the lamplight. What luck! Mike and Andi were soon at his side. All three could hear the stranger as plain as day, but his back was to them. A man, all dressed in black from head to toe. He began to speak as he removed black gloves from long thin white fingers. A gold ring gleamed on his little finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Have you any news for us, Mr. Hyde? What have you seen?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“No, I have seen nothing and have nothing to report.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“No sightings of humans, large or small?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“None. I’ve seen no one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Have you been patrolling as ordered?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes sir. There is no one in the woods, in the town, the neighborhoods, or surrounding farms. All seem abandoned. All is empty and quiet.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ours for the taking it would seem. However, here’s a coincidence. See who I’ve found on your own doorstep!” The figure all in black lifted a black bag from his side and poured out its contents onto the table. Out rolled Jo and Barkley!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“OH my Stars!” Andi clapped her hand to her mouth to keep from crying out. She held tightly onto Tony who looked scared and furious at the same time. Mike clenched and unclenched his hands. Andi pressed her pointer finger to her lips.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Henry Hyde stared at Jo and exclaimed, “Crikey! A kid and a dog. Dog must have got shrunk when she did.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo said nothing. She knelt on one knee beside the dog and had her arms around Barkley protectively, her eyes moving from Henry Hyde to the stranger and back again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hmmmm… maybe I can add the dog to my collection,” said Hyde.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Hyde’s guest replied, “Fine, but what about the girl? Keep her locked up here for now. I will ask the boss what he wants done with her. In the meantime, we need you to keep patrolling the woods. We don’t want anyone bumbling around sniffing about. No surprises. That’s what the boss pays you for.” And with that he brought out a wallet and dumped some gold and silver coins onto the table. Henry Hyde’s eyes widened and he smiled. A gold tooth gleamed in his mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“The old pirate! He’s working for them!” said Andi.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“For whom?” asked Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“For them!” repeated his sister. “The bad guys. The ones who have shrunken us and taken Mom and Dad away. He’s helping them. Spying for them. Why would he do that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“For money?” Mike suggested. “Some people will do bad things for money.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The dark stranger spoke again. “Keep your eyes and ears open for anyone who approaches. It’s just a matter of time")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt91.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("before the boss puts his plan into action. And then you will be rewarded for assisting us. I must go. Keep the girl for now. Do what you like with the dog,” waving a white hand in dismissal.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Just then Jo stood up on the table. She looked defiant, feet spread wide, hands on hips. “Wait just a minute.” Her voice was clear and strong. “You can’t keep me here. I demand that you let me and my dog go free. Who are you and what have you done to my parents? To all our parents. And why have you shrunk all the kids? You have no right to do this!” She was angry and breathing hard. She waited for some response.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Henry Hyde appeared shocked at this and said nothing. But the man dressed in black said to Jo, “I don’t have to explain myself to you, young lady. After all, you are in no position to order me about, are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Mr. Malarkey, is that really you? The assistant principal of the middle school??? How could you? You should be ashamed of yourself! It’s your job to discipline kids who misbehave. To teach us right when we do wrong. And look at you now! You big hypocrite!” Jo was furious.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo’s companions were proud of her. Tony whispered to Mike and Andi, “Yeah, he’s definitely in the wrong job!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo continued when Malarkey did not reply. “I want to know what is happening! Who are you working for? Where are my parents and why am I only this tall! I am waiting for your answer!” Jo crossed her arms and scowled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“You’re quite a brave lass, considering your size. So I’ll tell you a few things. Do you know how little an assistant principal is paid considering the aggravation he has to endure from all those brats at school, day in and day out??? So yes, I was willing to go along with Dr. Ratburger when he first approached me—”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Wait, who’s Dr. Ratburger?” demanded Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“He’s the space scientist who first made contact with our alien friends. As I was saying, when he made me a generous offer, I said sure. You must know that our planet is not the only one in the universe with life on it. But we are lucky enough to have one with clean air, clean water, soil for growing food, and all kinds of living things thriving on it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo interrupted again, “What does that have to do with me? With what you have done to us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Apparently, from what Dr. Ratburger has told me, the world that our alien friends come from has been thoroughly polluted, used up, and wrecked. They’ve ruined their own planet and now they want ours. Plain and simple.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“But who are they? And where are my parents?” Jo repeated her demands.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Stop interrupting, young lady. You will understand in time. Your parents have been taken to work for their new bosses. Don’t worry, they’re being treated well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“And we children?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“By shrinking all the children, you became much less of a problem.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“And that’s it?” Jo was yelling now. “How can you go along with such a despicable plan? Why, you’re a traitor to the whole human race! And to the Earth! And all creatures we share it with!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes, well, I don’t have any more time to explain to one insignificant teeny tiny girl.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi was shocked and dazed… “So that’s it! Gadzooks! What can we, just the four of us, and so small, ever hope to do to stop this crazy plan? We’ve no power. No real weapons. What are we going to do?” She lifted both hands to her head. “This is hopeless!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony grabbed her arm, “Here’s what I think. We have strength in numbers if we can get all our animal friends to help us. And I think they’ll help once they know what the evil scientist Ratburger and his friends intend to do. Our animal friends can spread the word and together we can take back our homes and free our parents. And figure out their shrinking machine, I hope, in order to make it work in reverse!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony imagined an immense battle scene. Armies and armies of animals, birds, insects, and children, representing all the world’s species, all arrayed in alliance around the alien army. And the amazing thing was that predator and prey would stand side by side because they had a common enemy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony was so excited he could barely keep his voice down. “Picture this! Waves and waves of kids riding on foxes and elephants, all kinds of four footed creatures, birds, insects, amphibians all banded together, shoulder to shoulder, wing to wing, filling the land, filling the air, surrounding those aliens in order to save the Earth from being taken over by beings who only want to use it up and destroy it!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh Tone, be realistic! What can a bunch of little kids and frogs do?” wailed his sister, still not catching on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I don’t know, but I bet a million frogs all together could really clog their carburetor!” then he scratched his head. “Mike, what’s a carburetor?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“It’s…” began Mike, who knew quite a bit about cars.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Never mind that now guys!” Andi hissed at them, pointing. “Look, he’s leaving! Now what do we do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mr. Malarkey pulled on his gloves as he strode to the door, opened and closed it without looking back. Henry Hyde reached up and took down a bird cage and set it on the table. Opened the door. “Get in,” he said to Jo. Jo and Barkley stepped in. He shut the cage door and lifted the cage up to the hook where it had been hanging. Then he laughed to himself as he picked up the coins. He carried them to an old chest and took from it a box. Took off the cover from the box and dropped in the coins. There was a clinking as the coins hit other coins. He put the box back in the chest and returned to the table. He finished his stew and his drink, turned down the lamp, stoked the fire, and went over to a small bed in the corner. He fell onto it and pulled up a blanket to his chin. After a few minutes, he began to snore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Now what?” whispered Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi whispered back, “First let’s let Jo know that we’re here.” And so they began to quietly call her name. They stood up on the shelf waving their arms. Barkley’s ears stood up. He looked in their direction and made a whining sound in this throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What’s the matter boy?” Jo asked. And she saw her three friends high up on a shelf across the floor of the treehouse. She waved happily. She no longer felt alone, although she was stuck in the cage. She waited confidently for her friends to rescue her, and Barkley too, before he could become another of old Hyde’s trophies.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("Chapter 14")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi, Tony and Mike conferred. What could they do? How could they get to Jo and Barkley? Andi knelt down and leaned over the edge of the shelf to see what was below. She saw a row of hooks with clothes hanging from them. She thought for a second and then stood up and said, “We can climb down from here on those clothes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Then what?” Tony wanted to know.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I don’t know yet. Let’s get down first.” And so she slid herself over the shelf’s edge and down the trouser legs of some blue jean overalls, almost all the way to the floor. She let go and landed with a little bump, but old Henry Hyde snored on. Soon Tony and Mike were beside her, and they tiptoed across the floor to get closer to the bird cage.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony said, “I have an idea. But first I need a green and bendy stick as tall as me from that kindling pile, not a dry and snappy one, and I need that cord from the rabbit snare on the table.” Andi said she’d get the stick and Mike began to climb up on the chair whispering that he would bring back the cord.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Once they had returned with the stick and the cord, Tony tested the stick. When he held one end between his feet and pulled down on the other end, the stick bowed in the middle but did not split or snap. “Great, this’ll work. May I use your jackknife, Andi?” He held out his hand like a surgeon waiting for a scalpel. He tied one end of the cord tight to one end of the stick. Then he measured the cord, cut it, and made a small loop at the free end. He held the stick between his feet again and began to bend it down, slipping the loop over the end of the stick, the stick now bent into a bow. He plucked the cord. It was tight. “Now for an arrow. Another stick please, Andi!” He notched one end of the stick she provided and deftly whittled the other end to a point. Then he tied a long piece of the rabbit snare cord to the arrow. Carefully coiling the cord at his feet, he whispered, “Well, here goes!” And then quietly he called up to Jo, “Jo, step back to the other side of the cage!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony aimed the arrow up at the cage and pulled back on the bow string with all his strength. He let go the arrow. It whizzed past his cheek and flew up, up, up, carrying the cord along with it. But it just missed the cage and fell back to the floor with a rattle which seemed so loud it was sure to wake Mr. Hyde. Henry Hyde muttered to himself and rolled over. He rolled back and pulled his blanket up over his head. He settled. And finally, as the kids held their breath, his snores became regular once again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That was close! Try it again, Tone!” said Andi, and she lightly ran out to retrieve the arrow. Tony coiled the cord again. Mike looked up and called out to Jo in a low voice, “Jo, here it comes again! Keep back! Back Barkley, quiet boy!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony pulled back the bowstring, aimed, and let go the arrow. This time it flew through the bars and landed on the floor of the cage. It began to slide toward the edge, and Jo jumped up to grab it. She untied the cord from the arrow and tied it instead to a bar of the cage nearest the door. She opened the cage door and then picked up Barkley, holding him under her left arm. She grabbed the cord in her right hand. “Okay,” she whispered loudly down to the kids on the floor, “Here I come!” And with that, she scooted off the edge of the cage. With her free arm and both legs wrapped around the cord, Jo began to slide down.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The plan was working perfectly! Closer and closer! Tony and Mike ran away with the free end of the cord so as to slow her descent. Finally she landed with a not too hard bump flat on her back with Barkley safe on her belly. She giggled, “Barkley Barkley get off me buddy!” They lay there, panting but happy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s get out of here, quick!” said Tony.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Wait! Is there anything here we can use? Take a quick look around.” suggested Andi. She spied a plaid wool scarf hanging from a hook. Tugging gently, it came down on her. Itchy but warm. She thought to herself, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’m sorry to take your scarf, Mr. Hyde, but we need it more than you do")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(". She said quietly, “Mike, hold this please.” She gave him one end of the scarf and took the other end and began to wind it around herself, getting dizzy, closer and closer to Mike and finally she was wrapped completely. Mike tied a piece of the cord around her. “I’ll take what’s left of this cord,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony hissed loudly, “Look at me!” Andi was shocked to see that he had donned a mouse skin with its head intact over his own. “Take that off right now, that’s horrible!” she demanded and Tony grinned. “Yeah, I admit it’s a little creepy. But it might be warm?” He thought better of it and took it off. “I’ll take my bow instead. And a few of these feathers may help any future arrows I might have to make.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’ll be in charge of my buddy,” said Jo, and she meant Barkley.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“You three get in the crate and I’ll lower you down,” said Mike. “Then I’ll climb down the ladder.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And with that they abandoned the abode of Henry Hyde, making their way away from the treehouse as best they could in the darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Our four small friends ran on and on till they could run no more, so they stumbled off the path in the dark to a sheltered place where they could fall down and sleep. Hopefully Henry Hyde would overlook their spot when he came looking for them, which they expected him to do at first light. They decided a fire was out of the question, so they all shared the warm wool scarf, compliments of Mr. Hyde.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("After what seemed practically no time at all, the ground began to shake with the regular thump of heavy footsteps, and our four friends could see the green trousered legs through the brush as they stomped past their hiding place. Mike sat up to keep watch so the other three could get more rest. Looking around, he recalled the events of the previous night. He was impressed by the bravery and cleverness of his companions. Mike wanted to be as good as they, so he thought hard about what they had found out the night before, and what they would need to do next. They were in quite a pickle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike became drowsy and started to nod off. But just as he was falling asleep, he thought he noticed a shadow pass over, and he opened both eyes wide. There were the green legs again, moving very quietly and slowly, back the way they had come. Mike froze. He glanced at his friends, all still asleep. If Mr. Hyde would just pass by before one of them woke up, all would be well. Mr. Hyde did just that, luckily, continuing down the path quietly, searching for them on each side of the path as he returned to his treehouse. Mike could hear Hyde grumbling about his bad luck at not finding them and having to report their escape. Mike almost felt sorry for him. At the same time, Mike knew the old fellow was dangerous. His friends were waking up, and so he reported to them what had happened.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I think we ought to travel after dark from now on and hide out during the day, just so we’d be harder for him to find. At least till we get clear of his place. What do you think?” Mike suggested.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Good idea, Mike,” agreed Andi.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-15"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("Chapter 15")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("So they stayed right where they were that day. Mike was tired after being on watch, so he curled up with Barkley and slept. Andi used her Swiss army knife to tear up Henry Hyde’s woolen scarf into four equal pieces. Then she made a slit in the middle of each piece big enough to go over her head and voila, four simple ponchos. She cut a bit off one edge for a belt. Tony and Jo wandered off a ways, looking for places where water ran in little rivulets or dripped from cracks in rocks. They foraged for nuts and brought back what they found to their campsite, keeping their voices down. Eventually, they heard the swish-swish of someone kicking up leaves on the path. Peering from their hiding place, they once again saw Henry Hyde slouching by. He would be back, they knew.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike woke up and kept watch. Everyone would need a nap if they were to hike the path all night. The path went uphill through the woods which covered the shoulders of Stone Mountain. Beyond the woods, there were only bare gray rocks, and then the Arch Monument stood alone at the summit. Still a few days away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("It was getting dark earlier now, in the late afternoon. They loaded up their belongings without speaking, and began their hike up the path. Henry Hyde had returned, grumbling to himself again as he passed them. The four friends believed it was now safe to travel the path. It was sort of hard to see, but their eyes adjusted to the moonlight that shone on the yellow leaves and guided them along.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("In the middle of the night, something, a big dark shadow, darker than the night, with two yellow eyes, all of a sudden filled the path in front of them. All they could make out were the eyes. Bobcat? Bear? Fisher cat? The children stopped hiking abruptly, fearfully drew their small swords, all were thinking, we’re in trouble. A low growl came from the shadow and the yellow eyes moved closer. And then there was a yelp of pain and the eyes disappeared. The shadow crashed off the path into the woods and was gone. The kids stood listening for a long time. Then Andi, Mike and Jo all said at once, “What was that? What happened to it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony held up his slingshot. “I shot it with a marble. Hit it right between the eyes. That must have hurt!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Good shot!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The rest of the night nothing bad happened, just the usual night noises, and they came to a stop next morning when the sky began to lighten. Jo kept watch while the other three lay down and slept. When they woke up, they played cards with a deck that Mike had in his pocket. What else would he pull from his pockets? He was practically a magician! They all practiced with Tony’s slingshot using acorns and with his bow and arrows. They checked out everything with the 10X. Then they scouted around and foraged for whatever they could find, staying away from the path. Tried to nap again. They made sure Barkley had his share to eat and drink. As soon as it was dark, they started up the path again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The young people found it difficult to sleep during the day, and very tiring and rather boring to hike at night. Henry Hyde had not shown himself again. After a few days, they decided they didn’t need to do it anymore. It took a day or two for their bodies to adjust to sleeping at night once again. They much preferred to be awake during the daylight hours and sleep when it was dark.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("A few more days went by. The trees were bare of leaves now, just black branches against the sky, except for the giant oak trees, whose copper leaves had turned to rusty brown and still held on, dried out and crackly, whispering and rattling whenever the branches moved in the wind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("One evening they stopped to make camp and found themselves near the shore of a small mountain lake. The water was very cold, and they took big drinks of it. Feeling refreshed, wrapping themselves in their warm wool ponchos, the four slept uninterrupted by the noises of the night.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Sun was shining on the rocky shore the next morning, and there were turtles sunning themselves. The turtles slipped into the water quickly when they heard the children approaching, all except one. It pulled its legs and head into its shell, then slowly peeked out at the group.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hi,” said Tony, with his usual friendly smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hello,” said the turtle. Feeling more confident in the face of such friendliness, she extended more of her neck, and blinked with head up, interested.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m Tony and this is Mike, Jo and Andi.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The turtle answered, “Pleased to meet you Tony. Everyone calls me Lulu. I’ve never seen you here before.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We live at the bottom of the mountain and are hiking to the summit. It’s a pleasure to have this opportunity to speak with a turtle. I have a question I’d really love to ask you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Sure,” said Lulu, “I’ll be happy to answer if I can.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How do you get through the winter? I can tell that you’re a painted turtle, right? Those red orange and yellow stripes on your legs and neck are very pretty. And your top shell is called a carapace, the bottom one a plastron. But I don’t understand what you do when it gets cold. Mind telling us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I bask here in the sun to warm myself, and to regulate my body temperature. That gives me the energy to slip into the water and look for food. Then I come out and bask and warm up again, and then repeat. That’s how I spend my days. At night I sleep in the water. And soon, very soon, I’ll go down to the bottom of the lake and dig into the mud. I’m designed so that my metabolism slows down. I won’t need food or much oxygen till Spring. When the water warms, I’ll swim up and start basking and feeding all over again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That’s amazing! Thank you for the explanation.” Tony sat down next to Lulu and tried skimming a rock on the water. “I love communicating with animals. They have a lot to say. And each species is unique. Nature is so cool, I love it!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("A loon suddenly called, mysterious and lonely, from the middle of the lake, and everyone looked up. On a bit of sandy shore not far they noticed a tall heron, intent on catching a fish. Andi said, “Look at that great blue heron, magnificent! I always think they look like pterodactyls, flying dinosaurs, don’t you? You can tell them from other big birds when they’re flying by their long legs trailing out behind them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Lulu said, “That’s Harriet.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi called to the heron, “Hello, Harriet, I’m Andi.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Harriet moved a little closer, standing in the shallow water. “Pleased to meet you, Andi, I’ve heard of you and your mission. Is there something I can do to help?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Thank you, Harriet. I’d like to know how far we are from the edge of the woods – where the woods come to an end and it’s just open rocks until you’re at the summit?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“It only takes me five minutes to fly from here to the edge of the woods, and another ten to get to the summit. You’re almost there. Pretty soon the lake will freeze and when it does I’ll have to leave for somewhere warmer, maybe near the coast, where there’s open water. Some of us fly all the way to the Caribbean, you know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Lulu chimed in, “I should go now, off to find some delicious algae. Hope to see you later!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“See ya later, Lulu!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("As they chatted, the children heard splashing and saw ripples as fish jumped out of the water, trying to catch the shiny flies that swarmed the water’s surface. Should they try to catch a fish? Tony and Mike decided to try it. They caught some shiny flies and pushed them onto a hook Mike formed from a paper clip he had in his pocket. Tied the hook to some twine he pulled out from another pocket. Then the two of them straddled a good sized stick floating near the shore and paddled with their hands away from shore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Be careful out there, Tone,” his sister called to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’ll hold onto him,” grinned Mike. Tony dropped the hook with the shiny flies into the water. The boys were quiet. Tony would jerk the string a little every few minutes. They waited. And waited some more. Tony was about to tell Mike that he could no longer feel his toes and they should give up when out of nowhere there was a tremendous tug on the line and a big splash and a good sized trout had grabbed the hook, and then it dove under. The two boys hung on, Tony holding onto the line, Mike holding onto Tony, as the stick log they straddled zipped along plowing the water, soaking them but they didn’t care. Andi and Jo and Barkley watched from the shore, jumping up and down on the rocks, amazed and all excited. “Hold on! Catch it, catch it!”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer046"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt106.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer047"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-16"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Chapter 16")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The trout put up a good fight pulling and splashing, but the boys held on, the twine didn’t break, and the fish eventually tired. Mike and Tony pulled it in and looked at it, all wet and shiny, brown speckled sides heaving. A beautiful and strong trout, almost as big as Tony. The boys were sad that it was dying, that they were responsible for its death, but they were hungry for it. They knew it would feed them well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi knew how to clean it. She’d helped her mom clean fish before. Jo helped her. Mike and Tony made a fire and warmed themselves, then constructed a spit to hold the trout. The fish skin browned and crisped as the boys turned it over the fire, and it smelled good. Barkley watched intently.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi said, “I just want to say before we eat this fish that I’m thankful for it. I’m sorry we had to kill it, but it will be good nourishment for the five of us. Counting Barkley of course. We won’t waste any of it. Watch out for bones. And make triple sure Barkley doesn’t get any bones in his fish.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Feeling very satisfied and full of fish, the grateful children sat back and watched the campfire. Andi said, “It must be getting close to the end of October. Almost Halloween. Guess we’ll miss trick or treating this year.” Tony hopped up and put his arms out and began walking stiff legged, “I’m a zombie! Or Mummy! Or Frankenstein, take your pick.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Do you believe in zombies and ghosts and witches and vampires?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Nah, not really. But being scared by the idea of them is sometimes fun,” said Jo. “Tony, what scares you the most?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That movie, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Jaws")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(". When the music goes bump, bump, bump, bump, bump, bump, bump, bump, faster and faster, that really scares me. Did you notice that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi nodded, saying, “Yes, I think the scariest thing in the world is in the movie ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Wizard of Oz")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(", when the house is up inside the cyclone and Dorothy sees Miss Gulch riding her bike out the window, and the music starts to go da dat da dah da dah dah faster and louder, and then she changes into the wicked witch. That used to really scare me when I was a kid.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ha-ha, you are a kid.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Oh yeah!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What a great movie. Great music. So what really scares you besides movies?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("They all thought for a minute. Jo was the first to speak. “I’m scared that I won’t see my family again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony confided, “I’m scared that I’ll be playing outfield for my little league team and a line drive ball will come right to me and I’ll drop it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi said kindly, “Don’t let your imagination run wild, Tone. Give yourself a pep talk. Believe in yourself. And practice a lot! You can do it. And remember it’s baseball, it’s supposed to be fun. And you Mike? What scares you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m worried about going back to normal. I’m always in trouble for something. Out here, not so much.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi said kindly, “I don’t know where we’d be without you Mike. Just remember that when you get back home. I’m scared about what will happen when we get up to the Arch. What if we can’t do it? I mean, get back to normal size and find our parents?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike blurted out suddenly, “You’re the smartest, bravest girl I ever knew Andi.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m not brave. I’m so scared I just want to close my eyes and get under my covers in my own bed and pretend it’s all just a bad dream.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes, but even though you’re afraid, you keep facing the problem and trying to do something about it, and that takes courage.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Thanks, Mike, I’ll remember you said that. It means a lot. What you think of me, I mean.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Mike, are you sweet on my sister?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike grinned and didn’t say anything. Andi was embarrassed and said, “Tony!” really loud. Jo grinned, and then they all laughed together. But Andi couldn’t seem to sit still. She hopped up and announced, “This might be our last campsite. Why don’t I scout ahead a little and see how far it is to the edge of the woods? Will you go with me Jo?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Sure! Let’s run!” So the two girls began jogging lightly up the path. Both of them loved to run. There was no way to tell how long they jogged before they slowed to a walk, as neither of the girls had any way of telling time, but it didn’t take long to see light at the end of the “tunnel.” Cautiously they peered out from behind the last gray tree trunk. There were the plain gray rocks of the summit before them, a wide open space with some short rough grass here and there. There was no trail of leaves out there but there was no need for a path anymore because they could see the Arch from where they were hiding. Gray stone against the gray sky, filling the sky it seemed so huge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The girls stared, not speaking, just observing carefully, and noted there was no activity, no sound around the monument. All was quiet and lonely. They looked at each other and Jo said, “I still don’t know what we’re going to do when we get there, do you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi admitted, “Not really, but we’ll think of something. Right now I can’t wait to get away and get back to camp. Ready?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo said, “Oh yeah!” and the two of them turned and jogged away from the Arch, back down the path through the woods. After a little while, they slowed to a walk. It seemed the lovely fall weather they had been enjoying was coming to an end. It was getting all gray and misty, and Andi felt chilled. She pulled her poncho tighter around her. A cold rain began to fall, wetting her face, and she realized she was tired, so tired, tired of wandering almost three months outdoors, tired of being pretty dirty and often hungry and always having to think and be wary. She wanted to go home.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("They walked through a stand of evergreen balsam fir trees and brushed against the tips of the branches. Andi breathed in the fresh scent of Christmas trees. That made her wonder if they’d all be snug at home with their families for Christmas. Not to mention Thanksgiving. She took in a big breath, and resolved to finish her quest. She said to Jo, “Oh that balsam fir smells so good. This would be a good spot for a campsite. In case we need to run back into the woods after we get up to the Arch. For whatever reason…” and left her thought unfinished. But she added, “Let’s go back and tell the boys about it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("When they returned to camp, the girls were pleased to see their friends Luke and Maya and Tanya and Toby, at ease and chatting with Mike and Tony. It seemed their animal friends had sensed the children might need them soon and had arrived at the camp to help if they could. Andi felt a huge surge of relief and happiness. It was so good to have friends! Everyone hunkered down to try to get out of the falling rain as best they could and get some rest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("They awoke to the sound of rain dripping on everything. When the wind blew, the trees swayed and the bare gray branches crackled and snapped, the dry leaves still attached rustled and scratched, the sound rising and falling as the wind came and went. Lulu and Harriet were nowhere to be seen. But the loon called its lonely call goodbye as they left their lakeside campsite.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("At the far end of the lake stood a dead tree full of large black lumps, which turned out to be vultures, their featherless red necks and heads pulled into their hunched shoulders. The kids stared at them quietly and even Tony had no comment. Didn’t offer any scientific explanation as to why they had no feathers on their head. He knew why but was preoccupied. The pair of red foxes with the big tails trotted up the path, and the children followed, while Luke and Maya, flew from branch to branch keeping watch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("A gaggle of long legged wild turkeys crossed the path up ahead, picking at the ground, moving off in single file.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("But the children said nothing, hardly noticing, each thinking their own thoughts. Their fingers were cold and stiff and their noses were red.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi laughed to herself. “These are weird thoughts I’m having.” She was thinking of young people from other lands. Were they just like her, only growing up in the desert or a tropical forest or the arctic or the flat farmlands in the center of the USA? Or big city dwellers? All the places in the world with different people and animal and plant species, foods, languages. Children all over the world were exploring their own environments. She wondered if they too appreciated their world and the amazing diversity of life in it. She hoped so. She felt connected to them all and was determined not to let them down.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo’s fingers wrapped around her little phone still deep in her pocket after all this time. She was wondering if it would ever ring again, if her mother would be calling her to say, “Hi Jo, see you soon, honey.” Jo wiped her cheeks, was it rain or tears? She felt ready to do whatever it took to rescue all their moms and dads.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike smiled at Barkley. Barkley looked up at him with big dark eyes, trusting Mike. “Don’t worry buddy, I’ll take care of you.” He was looking forward now to getting home to his family. Even his big sister. He missed them all.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony thought back over the past few months. He’d love to be home on the couch, all warm, watching TV and eating pizza, but he had to admit that living in the outdoors and communicating with the animals was fantastic. He was certain he would never forget it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The travelers arrived back at the stand of balsam fir trees and moved off the path, onto the dry needles and tiny cones beneath the firs. Dropped their excess gear. Looked at each other. “Ready? Shall we go?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s go!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s move out!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s do this!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And so they did.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer049"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt113.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer050"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-17"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("Chapter 17")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The four youngsters and their animal friends peeked over the top of the gray ledge of rock. There was the Arch Monument, at least fifty feet tall, built of smooth blocks of gray stone. A wide stone terrace surrounded the tall arch, and steep stairs of stone led from the terrace down to the rocky ground of the mountaintop. All very beautiful but unfriendly, quiet but uneasy. They observed in silence for a while, and suddenly there was a flurry of activity. A group of small silvery drones buzzed, clicked and whirred from the sky down to the Arch. One part of the stone face swung inward without a sound, revealing a deep empty square of blackness. The little drones buzzed in and the door swung shut.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Did you see that!” Tony pointed and exclaimed excitedly. “That’s it! That’s our way in!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("From their hiding place, the children continued to make an inspection of the Arch. Now that they had reached their destination, they were unsure exactly what to do next. They could see there were many security cameras mounted on top of the Arch, constantly moving back and forth. On the far side of the Arch, Andi saw the Power Towers, huge constructions of steel beams that held thick power cables on their shoulders. The ends of the power lines seemed to go right into the Arch. One after the other, evenly spaced and motionless, the great constructions of steel disappeared from view over the side and down the mountain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("There was no living thing visible. No sounds were heard other than an occasional gust of cold wind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Now what do we do?” Jo asked as she plopped down on a rock and crossed her arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’ve got to get inside, that’s all there is to it!” repeated Tony emphatically. “If we could fly in behind some of the buzzy little drones, maybe we could get in before the door closed. Luke and Maya, do you think you could do it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Absolutely! Just give us the signal and we can zip you right in!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Okay, that’s one thing solved. Tanya and Toby,” said Tony, continuing, “I think you two should go back and spread the word to all our animal friends that we need them now at the Arch!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Righto, will do!” and the two foxes turned to make their way down the rocky slope.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Now we’ll just have to be patient and wait for some drones.” And so they did. Eventually another party of drones arrived and the kids were ready. The two crows with their little human (and doggy) passengers zipped through the door and it immediately closed after them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("They found themselves in a long dark passageway lit with little red lights. No one was about. At the end of the hallway, there were two elevator doors. They watched as the hovering drones ahead of them entered the elevator. The doors closed. One elevator had an up arrow. The other elevator had a down arrow. The drones had gone down. Now our friends had to make a decision. Which way should they go?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Let’s stick together and all of us go up first, what do you think?” Andi asked her companions, and they all agreed. So four kids, a dog and two crows popped into the elevator. It was like a big empty box of silvery metal.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer052"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt116.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer053"
    }
  }, [_c('p', {
    staticClass: "InDent-Txt"
  }, [_vm._v("“We can’t reach the button to close the door!” laughed Tony, as he pointed up to the red dot.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Stand on my shoulders Andi and punch that button!” suggested Mike, and so she did.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The elevator went up and the door opened onto a large room with a desk, but there was no one there. Computers and odd equipment, gizmos and gadgets covered countertops around the room. Charts and graphs, maps and diagrams of the solar system and the earth covered the walls. The coolest thing was that the ceiling could open at the push of a button to reveal the sky. A telescope and a strange large machine on a platform in the center of the room could be raised up through the opening. A sign on the machine said, “Danger! Shrinkalator! Caution!” There were two levers on the side of the machine, one labeled “Shrink” and the other “Reverse.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Wow, look at this place and all this stuff. Anybody interested in being a space scientist?” asked Tony as he wandered around, fascinated.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Well here it is. What we’ve been looking for. Now we can get back to normal. Shall we?” Jo asked as she examined the Shrinkalator machine.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mike thought a minute. “If we do, then we’ll no longer be able to fly with Luke and Maya, or even communicate with them. We may need that ability yet. And it is easier to hide like this. At least we know now about the Shrinkalator machine. Let’s wait and see what we find downstairs and then come back. What do you think?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The four children agreed to Mike’s plan and returned to the elevator. They all looked at each other. Then Tony said, “Let’s do this!” And so they punched the red button and headed down.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("When the elevator stopped and the doors opened, bright lights lit the shiny gray concrete floor before them. Looking up, they could see out into a huge underground cavern which had been carved out of the rock under the mountaintop. The open area of the cavern floor was occupied by hundreds of people milling around, all busy working at different tasks. Immediately in front of the children, however, was a wall of glass window separating the elevator area from the work floor below. A row of computer screens lined the window, and there sat two people in swivel chairs with their backs to the children. The two men appeared to be in deep conversation with a hovering drone. One of the men was Mr. Malarkey. He glanced over at the open elevator and saw the children. He jumped up shocked with mouth open and pointed to them. “We have company!” he yelled to his companion. “Uninvited guests.” The other man swiveled around in his chair to face the children. He was a stout bald fellow wearing round wire glasses and a white lab coat. “Dr. Ratburger,” it said on his lapel pin.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“What’s this?” he smiled. “Come in, come in. Ahhhh! Several small specimens successfully shrunken with my ingenious Shrinkalator. Come closer please so I may examine you.” He sounded quite proud of himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The children stepped forward, flanked by their feathered friends. Andi said very seriously, “Dr. Ratburger, is it? We’ve come to talk to you. We want to be our normal selves again. We want our parents back. And we want you to stop your campaign to give away our air and water and animals. Geesh! That’s crazy! Why would you do such a thing? We think there is a better way. Why don’t we share our resources and technology? We can teach them what they need to know to thrive. Well Doctor, may we have your response please?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Dr. Ratburger was afraid of the aliens. Yet he worked with them because he wanted revenge on his scientific colleagues, who had once dismissed his ideas as dumb.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Kids, meet Mr. Twisp.” Dr. Ratburger waved his hand toward one of the small drones. The drone stopped hovering and landed on the floor next to the children. A silvery panel slid soundlessly to the side, and a creature exited.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("About a foot tall, with a large pale head and extremely skinny arms, legs and fingers, the alien looked at them with large dark eyes, blinking, and then spoke.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Greetings small humans. Dr. R. has told me so little about you. I am called Twisp. I come from Planet Twitter far beyond your solar system. Your planet has everything we need to start over as we’ve made a real mess of Twitter. Dr. R. has kindly offered to be of assistance.” Mr. Twisp blinked and then looked at Dr. R.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony stepped forward and held out his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m very pleased to meet you Mr. Twisp. I’m Tony, this is my sister Andi, and these are our friends Mike, his dog Barkley, Joanne, and Luke and Maya. Everyone, meet Mr. Twisp.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hi!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Nice to meetcha!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ruff-ruff.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony continued. “We’re here because Dr. R. hasn’t any right to give you our planet, to shrink us and kidnap our parents. We do not agree with his plan, nor do our animal friends. But we think we can find a solution if we negotiate. Share. Understand?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mr. Twisp replied solemnly, “I am familiar with those concepts. However, we have determined we need your resources. Our bodies have no strength because we have not used them for many, many ages, so we must have your adult humans to labor on our behalf. We cannot alter this decision. Plans are in motion and it’s too late to stop now. That would be a disaster for all Twispy Twitters.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mr. Twisp turned to Dr. R. and asked, “Is that not correct Dr. R.?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Absolutely, oh yes. That is, what you’ve just said is entirely correct. Cannot be changed. Oh no. Absolutely positively impossible. Out of the question!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Wait!” Andi commanded. “No way can this happen. We can share. This means we help you without your taking everything. We can work with you. It doesn’t have to be all or nothing. It’s called compromise. Right, Mr. M? Dr. R.?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The two men frowned at her. Dr. R. pushed a button.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Okay. Time is up. We’ve work to do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Two men appeared and looked surprised to see the children. Dr. R. said to them, “Bingo and Bongo, take these children to the holding cell. We’ll deal with them later.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer054"
    }
  }, [_c('p', {
    staticClass: "Chapters-123456789 ParaOverride-3",
    attrs: {
      "id": "_idParaDest-18"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v("Chapter 18")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi looked at her friends. “Time to go, guys!” She hopped on Luke and gave a hand up to Jo behind her. Mike and Tony sprang up on Maya. Mike reached down to scoop up Barkley, and the two crows lifted off the gray floor and flew away, out over the warehouse floor.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("People were sitting at computers in cubicles and typing. Some were examining printouts and making calculations. Others were moving quickly, carrying things and operating forklifts and little go carts from one area to another. Most were wearing white lab coats. Not one of them noticed the two birds and their passengers streaking by overhead.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’ve got to get out!” Andi called over her shoulder to Jo and saw drones behind them. She leaned over and whispered to Luke and he began evasive maneuvers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Head back to the elevator. We’ll have to chance it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The crows circled back toward the elevator and at the last minute, Luke turned so that Andi could lean over and punch the button with the up arrow. Luke looped back and swooped into the elevator as the doors opened, Maya close behind, and the doors closed. The last thing they saw was Dr. R. and Mr. M. and Bingo and Bongo staring at them with mouths open.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The elevator doors opened and down the corridor they flew. Now an alarm bell was ringing. Several drones with red lights flashing chased them down the passageway.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How do we get the door open?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Not sure yet!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("All of a sudden there was a bright blue square of daylight ahead. They could see a formation of hovering drones blocking the exit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Luke, can you make it through?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hold on tight, here we go!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And suddenly they were looping, flipping and whirling in beautiful flight as only crows can do, right through the line of drones, oh so lightly and nimbly. The drones turned to follow. Luke and Maya and their companions hurtled over the rock ledges, heads down, wind streaming past, and there appeared a flock of crows to greet them, milling around them and scattering up in all directions, confusing the drones. The drones followed the wrong crows, and our friends were able to fly down the mountain to the edge of the woods. Luke and Maya landed and the kids hopped off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("One drone, however, had stuck with them and had not been fooled. It blinked and whizzed its way so it was hovering over them. What now?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The children slowly backed away. The drone landed in front of them. After a few minutes the silvery panel opened and out came the alien pilot, looking very similar to Mr. Twisp.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The alien being blinked its large dark eyes at them and said, “Hello humans and animal friends. I’m Twittle Twispy. You met my dad. He doesn’t like to change his mind once he’s made a decision. But I opened the door for you to escape because I want to know more about you and what you were saying back there. May I join you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Speechless, the four friends nodded yes. Finally, Tony elbowed his sister and she spoke up. “Of course, we’d love to get to know you better. Please come with us to our camp, it’s not far. I’m Andi and this is Mike, Tony, Jo Jo, Barkley, Luke and Maya.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("“I’m pleased to make your acquaintance,” said Twittle politely.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Everybody marched back to their camp beneath the balsam fir trees, not far from the wood’s edge, with Twittle following in his hovering drone, and they all sat down together. Pretty soon Twittle noticed they were not alone. Very quietly, one by one, the creatures of the woods gathered around to stare at Twittle and listen to his story. He began with an apology.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I’m sorry for what we’ve done to you and your parents. Sometimes the folks in charge get things wrong. I’m hoping with your help to come up with a plan that works for you and for us. And then I’ll explain it to my dad.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi responded, “That’s wonderful! We agree with you and will do anything to help, won’t we?” Everyone nodded their heads up and down happily.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi continued, “I think we need to show how strong we are to Dr. R and Mr. M. so they’ll see their plan won’t work. Hopefully no violence will be necessary, but they need to see that we are all united against their plan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’ll need to get the word to all our animal friends to stand with us at the Monument,” said Tony. All the creatures listening nodded in agreement.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“How do we convince your dad that Dr. R and Mr. M are bad dudes and are doing this for their own personal gain?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yeah, they’re twisted!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Losers!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andi wrinkled her forehead, concentrating. She asked Twittle, “Do you think your dad would change his mind if we gave him a chance to hear for himself that Dr. R and Mr. M are a couple of dishonorable characters?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Twittle thought for a minute and answered solemnly, “I do. I think he would. What do you propose, Andi?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The little group talked on, got to know each other, and made their plans. Jo said shyly, “Twittle, you’re awfully thin, are you Okay?” Twittle smiled back. “I’m fine. Over time we just lost the need for strong bodies because we didn’t do work or play or do physical things or go out into our polluted world anymore. So that’s how we evolved. All brains and no brawn, and very pale, as you can see from my big head and teeny muscles. Luckily we have some amazing brain powers to compensate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Like what?” asked the four kids all at once, eager to know.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Well, we have communication skills so I can understand many languages and can communicate with many species.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That’s wonderful. That will be a big help when we’re negotiating,” said Jo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Yes,” Andi added, “For some reason we’ve been given the power to communicate with the animals since we’ve been shrunk. That’s one thing I will really miss when we get back to normal size.” She looked into the eyes of Luke and Maya, and she could tell they were smiling at her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Their animal friends scattered to spread the news of the great March on the Arch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tony asked, “May I take a spin in your drone?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Sure!” replied Twittle. It was a tight squeeze inside the drone. Twittle pressed buttons and the drone rose and hovered. Then he pulled a lever and the drone zoomed forward.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Sweet!” Tony laughed. “May I try?” After a while, all the kids having had a spin in Twittle’s spacecraft, Twittle asked, “May I take a spin on your back?” he asked Luke. “The flying skills of your species are extremely admirable.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Sure,” said Luke. “Hop on!” Tony and Mike lifted Twittle")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer056"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt125.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer057"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("onto Luke’s back, and Andi hopped onto Maya. Together, they rode through the woods, down the main path a few feet up from the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“We’d better stay low to avoid being seen by any drone scouts,” she explained.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Wow, feathers and wings are amazing things. We may have had birds on Twitter long ago, I don’t know for sure,” said Twittle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Aren’t there any animals or birds or fish or other wildlife left on your planet?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Not anymore,” he said sadly. “Nothing grows there. It’s dirty and gray.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“That’s terrible. I’m sure we can help. But it may take some time to repair your planet. Earth did not become this way overnight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“A million years?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“With all your technology and brain power, I know you’ll figure it out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("So the new friends camped and had a campfire. Shared what they had to eat. Swung on a few vines, played some cards, told some jokes. Showed Twittle a good time. Asked him tons of questions. Finally slept beneath the trees under the stars, wrapped in their wool ponchos. Would this be their last night in the outdoors? Next day would be big.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("In the morning, Twittle said goodbye. He flew off in his drone headed to the Twispy Twitter mothership. He planned to speak with his dad and hopefully turn off the Power Towers. The children, Luke and Maya flew to the Monument and landed on the very tippity top of the Arch. They smiled and waved into the security cameras, waiting. Soon Dr. R and Mr. M came running out at the bottom of the Monument and looked up at them. They spoke to each other and then called for Bingo and Bongo. But before they had a chance to move, they all were surprised. The Power Towers snapped the cables off their shoulders. The electricity cables that powered the Monument and all its underground goings on now laid on the ground, broken. The Power Towers moved toward the Arch and formed a squad of steel and stood silently, waiting.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Twittle’s drone arrived and landed on top of the Monument. Mr. Twispy stepped out, and Tony and Mike showed him where to stand behind a security camera. Twittle joined the children. Looking out, Andi could see her neighborhood far below. She wrapped herself in her poncho. As she watched, groups, gaggles, flocks and herds of creatures, four footed or winged, all standing or hovering shoulder to shoulder, began to surround the Arch, facing the friends. It was an impressive sight. The kids stared out happily, and Tony waved his arms ecstatically to the animal armies arrayed in front of them and cried out, “Awesome!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Dr. R and Mr. M rushed in to the monument and stormed up some secret stairs and exited onto the top of the Arch through a trap door. Dr. R looked out and was shocked to see the array of birds and animals, standing or hovering, all looking right at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("He whined, “What is this? What is going on?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mr. Malarkey looked at him, disgusted. “Stop whining. We’ve got this. Let’s just aim the Shrinkalator at this mob. That’ll take care of ’em. They won’t get in the way of our plan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“And what exactly is your plan, Mr. M?” asked Jo. “Please remind us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Not you again, young lady!” Mr. M was annoyed but then boasted, “We are going to become millionaires! Dr. R’s inventions are going to make us rich and powerful! And no kids or mobs of unimportant creatures can stop us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Actually,” said Dr. R, “that is not my true motivation. I wanted to get back at my scientific colleagues for not taking me seriously. They laughed at my ideas and that hurt me. I don’t care about the money really.” He looked at Andi, surprised at his revelation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Are you nuts, Ratburger?” roared Mr. M, glaring down at his partner in crime.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Dr. Ratburger, surely you can see that Mr. M is taking advantage of you? That what you’ve been doing is wrong?” asked Andi.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("At that moment, Mr. Twisp stepped out and greeted Dr. R quietly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I have heard from my son and his young friends a new way of thinking. I quite admire their resourcefulness and pluck to have come all this way at their size through the wild world, and so I think they deserve to be heard. I have determined that our plan can change after all. Twittle, please arrange a meeting with Dr. R. and Mr. M. so they can hear your friends’ ideas. I’m sure they can make the necessary adjustments. Right Dr. R.?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Huh? Oh, well, yes, of course, of course. Whatever you say Mr. T.” He looked sad and began muttering to himself. On the other hand, Mr. Malarkey was angry. “I will not allow these four little whippersnappers to get in the way! We’re going to make millions off this deal. We have the power to do whatever we want with our Shrinkalator and other inventions! We’re in charge and under no circumstances are we changing anything!” With hands on hips, he faced our friends defiantly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Ahhh, sorry Mr. M., you’ve lost your power…literally.” The kids giggled. The security cameras had stopped turning. Deep inside the mountaintop, the warehouse floor was now dark and still.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mr. Malarkey yelled out to the Power Towers, “You there, turn that power back on!” But they remained still.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“The Power Towers are on the side of good, Mr. M. Face it, you’ve lost. Be a part of the solution. What do you say?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I say, never!” and with that he ran away down the stairs, followed by Dr. R and Bingo and Bongo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("And so our four friends linked arms and stood gazing out over all the animals and birds gathered on the slopes. They put their arms around Twittle’s shoulders too, and around Barkley and Luke and Maya. Far below, they could see their homes and neighborhood where they had started out on their journey almost four months ago. Pretty soon they’d go turn on that Shrinkalator and hit the “reverse” button and find their folks and go home. But right now they were very happy to be young and small and alive.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Jo’s cellphone, still in her pocket after all this time, began ringing. They all jumped at the sound, and she answered with a question in her voice;")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Hello?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Mom!”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer059"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9798886937718_Txt130.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer060"
    }
  }, [_c('p', {
    staticClass: "About-Author ParaOverride-3"
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Andrea Adams grew up in a small town free to play and roam the fields and woods till dark. The author lives with her husband in Exeter, New Hampshire.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e4a8322","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epub.vue
// module id = 57
// module chunks = 0